// Materialized from the owner-verified version 9 source bundle.
// Card IDs are lookup destinations, not sequential spoken steps.
// Original manuscript/crosswalk copies preserve all context and mapping fields.
export const V9_CARD_IDS = [
  "S01",
  "S02",
  "S03",
  "S04",
  "S05",
  "S06",
  "S07",
  "P01",
  "P02",
  "P03",
  "O01",
  "O02",
  "O03",
  "O04",
  "O05",
  "O06",
  "O07",
  "O08",
  "O09",
  "O10",
  "O11",
  "O12",
  "O13",
  "O14",
  "O15",
  "O16",
  "O17",
  "O18",
  "G01",
  "G02",
  "G03",
  "G04",
  "F01",
  "F02",
  "F03",
  "F04",
  "F05",
  "F06",
  "F07",
  "F08",
  "F09",
  "F10",
  "F11",
  "F12",
  "F13",
  "F14",
  "F15",
  "F16",
  "F17",
  "F18",
  "F19",
  "F20",
  "C01",
  "C02",
  "C03",
  "C04",
  "N01",
  "E01",
  "E02",
  "E03",
  "I01",
  "I02"
] as const;
export type V9CardId = typeof V9_CARD_IDS[number];
export interface V9SpokenVariant { readonly id: string; readonly label: string; readonly text: string; readonly sourceStart: number; readonly sourceEnd: number }
export interface V9SourceCard { readonly id: V9CardId; readonly title: string; readonly body: string; readonly variants: readonly V9SpokenVariant[]; readonly quotes: readonly string[] }
export interface V9SourcePurpose { readonly old_id: string; readonly old_title: string; readonly new_card: V9CardId; readonly treatment: 'Changed' | 'Merged' | 'Direct'; readonly reason: string }
export const V9_SOURCE_METADATA = {
  "version": 9,
  "bundleSha256": "e111a74890d9b2b531f130cade61ba1ecb46dc2caf858fba87c25e692e01863d",
  "bundleBytes": 160790,
  "manuscriptSha256": "1fed965501dffe1dd669133e78e3eabdbffa029578f3211605a0016f4b5d926d",
  "crosswalkSha256": "8da91f7fdc40da1d9d73a453345115381e20573768ae19a34c342b4f53e0fc46",
  "playbookDocxSha256": "eb8df3b17ff24ddc74104dcc56fba5b5895de281b2d078ac79118299ee1dd629",
  "comparisonDocxSha256": "1c51c5eff8135db82ff5ff4b871956044b72ed0c7e805080cc23e6027400a761",
  "historicalSourceCommit": "2999051010e64b72bfa597d5112bb2fe1b341a0e",
  "inspectedEffectiveGraphCommit": "3a88402",
  "sourcePurposeCount": 181,
  "lookupCardCount": 62
} as const;
export const V9_CARDS: Readonly<Record<V9CardId, V9SourceCard>> = {
  "S01": {
    "id": "S01",
    "title": "Explain what AvertSignal does and why you called",
    "body": "**Say:** “Hey, it’s [Rep] with AvertSignal. I’ll be straight with you. This is a cold call. I’ll keep it brief.”\n\n**Default reason:** “The reason I’m calling is we help businesses catch problems that can cost them customers. That could be people having trouble finding you online, a request never reaching your team, or a lead sitting there without a follow-up.” Then ask S03’s opening question and listen. These are possible problems, not findings about this business. Do not open with the founder story or claim every business needs this.\n\n**Known local/search priority, use instead:** “We help businesses catch website and local listing problems that can make it harder for customers to find or contact them.” Then “How do you check that customers can find the right contact details online?” Use one reason and one relevant question, not both versions. Keep public checks distinct from connected routing/follow-up checks.\n\n**Unknown role or general number:** “Who looks after the website and how new customer requests are handled?” → G01 only when needed. A known relevant buyer skips routing. Reuse role or provider facts already supplied.\n\n**Asked the reason first:** give the relevant reason/F01, then only the unanswered question. **Busy:** O08. **Ordinary not interested:** O01, one relevant clarification at most. **Stop/final refusal:** E01. **Informed ready buyer:** C01. No mandatory permission gate, fixed-duration promise or invented prior relationship.\n\n**Founder background:** optional after one or two exchanges in S04, when useful or requested. It never delays a direct answer.",
    "variants": [
      {
        "id": "introduction",
        "label": "Say",
        "text": "Hey, it’s [Rep] with AvertSignal. I’ll be straight with you. This is a cold call. I’ll keep it brief.",
        "sourceStart": 10,
        "sourceEnd": 111
      },
      {
        "id": "default-reason",
        "label": "Default reason",
        "text": "The reason I’m calling is we help businesses catch problems that can cost them customers. That could be people having trouble finding you online, a request never reaching your team, or a lead sitting there without a follow-up.",
        "sourceStart": 135,
        "sourceEnd": 361
      },
      {
        "id": "local-reason",
        "label": "Known local/search priority, use instead",
        "text": "We help businesses catch website and local listing problems that can make it harder for customers to find or contact them.",
        "sourceStart": 589,
        "sourceEnd": 711
      },
      {
        "id": "local-awareness",
        "label": "Known local/search priority, use instead",
        "text": "How do you check that customers can find the right contact details online?",
        "sourceStart": 719,
        "sourceEnd": 793
      },
      {
        "id": "unknown-role",
        "label": "Unknown role or general number",
        "text": "Who looks after the website and how new customer requests are handled?",
        "sourceStart": 963,
        "sourceEnd": 1033
      }
    ],
    "quotes": [
      "Hey, it’s [Rep] with AvertSignal. I’ll be straight with you. This is a cold call. I’ll keep it brief.",
      "The reason I’m calling is we help businesses catch problems that can cost them customers. That could be people having trouble finding you online, a request never reaching your team, or a lead sitting there without a follow-up.",
      "We help businesses catch website and local listing problems that can make it harder for customers to find or contact them.",
      "How do you check that customers can find the right contact details online?",
      "Who looks after the website and how new customer requests are handled?"
    ]
  },
  "S02": {
    "id": "S02",
    "title": "Use a relevant research fact only when useful",
    "body": "**Entry:** A current, sourceable observation actually changes the next question.\n\n**Say:** “I saw [specific public fact] on [source]. Is that still accurate?”\n\n**Confirmed:** use it once and continue S03/S04. **Corrected:** “Thanks. I'll work from [corrected fact].” Replace the preliminary fact; do not defend outdated research. **Uncertain:** keep it preliminary; ask only what matters to fit. **Potential fault observed:** explain the exact test, time and limitation; do not claim harm or ownership from one result. **No relevant research:** skip this card entirely.",
    "variants": [
      {
        "id": "research",
        "label": "Say",
        "text": "I saw [specific public fact] on [source]. Is that still accurate?",
        "sourceStart": 92,
        "sourceEnd": 157
      },
      {
        "id": "corrected",
        "label": "Corrected",
        "text": "Thanks. I'll work from [corrected fact].",
        "sourceStart": 225,
        "sourceEnd": 265
      }
    ],
    "quotes": [
      "I saw [specific public fact] on [source]. Is that still accurate?",
      "Thanks. I'll work from [corrected fact]."
    ]
  },
  "S03": {
    "id": "S03",
    "title": "One current-awareness exchange",
    "body": "**After the default service reason:** “If a new customer’s request didn’t reach the right person or didn’t get a reply, how would you find out?” This is the only general detection/notification question. The local/search route uses its paired contact-details question instead.\n\nThe answer selects S04’s relevant explanation and can establish system, handler, existing checks, notification preference, threshold, quantity or authority. Record all facts it supplies. There is no follow-up question about how they hear about problems, provider notification or high-volume prioritization. A later exact system question is legitimate only when it resolves a distinct missing fit fact.\n\nKnown provider or owner → the matching S04 explanation. No known detection → explain the available check without declaring an actual failure. Public-only → local/contact/technical-search example, no forced CRM interview. Unknown role → G01. Explicit stop → E01. Informed purchase request → C01. Early price → direct S07 answer, then the next unsatisfied decision, not a second question followed by this one.",
    "variants": [
      {
        "id": "awareness",
        "label": "After the default service reason",
        "text": "If a new customer’s request didn’t reach the right person or didn’t get a reply, how would you find out?",
        "sourceStart": 39,
        "sourceEnd": 143
      }
    ],
    "quotes": [
      "If a new customer’s request didn’t reach the right person or didn’t get a reply, how would you find out?"
    ]
  },
  "S04": {
    "id": "S04",
    "title": "One relevant addition and one wanted-check judgment",
    "body": "**Named team/provider, stalled-lead example:** “Your [named team/provider] keeps doing that work. For example, we can flag a lead that hasn’t progressed after a limit you choose, such as 24 or 48 hours. The notification identifies which lead needs attention, with evidence and next checks where available. Your team handles the follow-up.”\n\n**Owner handles it:** “We can flag a lead that hasn’t progressed after the limit you set and notify you with the findings. You still handle the customer.”\n\n**Provider already monitors:** “They keep doing that. AvertSignal gives you a separate check and evidence you can both use.” Add only the relevant example not yet explained. Capable monitoring is not a disqualification or evidence of a gap.\n\n**Public/local alternative:** “For example, a wrong phone number on a Google listing can stop customers getting through. We flag the finding so you can pass it to [named person].” Technical-search alternative: “A page can open normally but have a setting that tells search engines not to show it.” Contact delivery is an alternative only when that exact check is supported. Choose one hypothetical, not a barrage of possible failures or a claimed finding about this buyer.\n\n**The single judgment:** “Is that a check you’d want alongside what you have?” A specific yes → S05’s missing fit facts. No wanted addition → E02/E01 as appropriate. A factual question gets its answer and exact return. A clear volunteered wish for the explained check already resolves this decision; do not ask the buyer to confirm the same wish.\n\n**If asked what the finding tells them:** “We show what we found and what to check next. When the evidence confirms the cause, we explain it.” Suggested checks remain possibilities. No required demonstration; a real available example may be used if wanted.\n\n**Optional later founder answer:** “Our founder spent years helping businesses bring in customers through ads and SEO. He kept seeing the systems behind that work break. That’s why he built AvertSignal.” Use when useful or asked after the exchanges. It replaces context needed then, rather than extending an example into another speech.\n\nS04 contains no current-notification question and no mandatory follow-on “why would that help?” stage. The buyer’s team performs customer follow-up; AvertSignal detects and notifies.",
    "variants": [
      {
        "id": "provider-example",
        "label": "Named team/provider, stalled-lead example",
        "text": "Your [named team/provider] keeps doing that work. For example, we can flag a lead that hasn’t progressed after a limit you choose, such as 24 or 48 hours. The notification identifies which lead needs attention, with evidence and next checks where available. Your team handles the follow-up.",
        "sourceStart": 48,
        "sourceEnd": 338
      },
      {
        "id": "owner-example",
        "label": "Owner handles it",
        "text": "We can flag a lead that hasn’t progressed after the limit you set and notify you with the findings. You still handle the customer.",
        "sourceStart": 364,
        "sourceEnd": 494
      },
      {
        "id": "provider-monitors",
        "label": "Provider already monitors",
        "text": "They keep doing that. AvertSignal gives you a separate check and evidence you can both use.",
        "sourceStart": 529,
        "sourceEnd": 620
      },
      {
        "id": "local-example",
        "label": "Public/local alternative",
        "text": "For example, a wrong phone number on a Google listing can stop customers getting through. We flag the finding so you can pass it to [named person].",
        "sourceStart": 770,
        "sourceEnd": 917
      },
      {
        "id": "technical-search-example",
        "label": "Public/local alternative",
        "text": "A page can open normally but have a setting that tells search engines not to show it.",
        "sourceStart": 950,
        "sourceEnd": 1035
      },
      {
        "id": "wanted-check",
        "label": "The single judgment",
        "text": "Is that a check you’d want alongside what you have?",
        "sourceStart": 1239,
        "sourceEnd": 1290
      },
      {
        "id": "findings",
        "label": "If asked what the finding tells them",
        "text": "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
        "sourceStart": 1604,
        "sourceEnd": 1702
      },
      {
        "id": "founder",
        "label": "Optional later founder answer",
        "text": "Our founder spent years helping businesses bring in customers through ads and SEO. He kept seeing the systems behind that work break. That’s why he built AvertSignal.",
        "sourceStart": 1855,
        "sourceEnd": 2021
      }
    ],
    "quotes": [
      "Your [named team/provider] keeps doing that work. For example, we can flag a lead that hasn’t progressed after a limit you choose, such as 24 or 48 hours. The notification identifies which lead needs attention, with evidence and next checks where available. Your team handles the follow-up.",
      "We can flag a lead that hasn’t progressed after the limit you set and notify you with the findings. You still handle the customer.",
      "They keep doing that. AvertSignal gives you a separate check and evidence you can both use.",
      "For example, a wrong phone number on a Google listing can stop customers getting through. We flag the finding so you can pass it to [named person].",
      "A page can open normally but have a setting that tells search engines not to show it.",
      "Is that a check you’d want alongside what you have?",
      "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
      "Our founder spent years helping businesses bring in customers through ads and SEO. He kept seeing the systems behind that work break. That’s why he built AvertSignal."
    ]
  },
  "S05": {
    "id": "S05",
    "title": "Only missing fit and configuration facts",
    "body": "Entry: the specific check is wanted, or an informed buyer asks for a fitting plan. This card has no value explanation, usefulness test, impact confession or alert-content question.\n\nGenerate only the next distinct material dependency from the facts already supplied:\n\n- **System needed for the chosen check:** “Which customer system are you using?” HubSpot is ready; custom CRM always requires Shield. Another named CRM → F18. A named system in S03 creates no system question here.\n- **Stalled-lead threshold not already specified and needed now:** “How long would you want a lead to sit without progressing before you’re notified?” The threshold determines the business rule, not scan frequency or exact delivery time. Record a supplied 24/48-hour requirement directly. Configuration can be completed in onboarding when it does not change fit or the purchase decision.\n- **Quoted quantity missing:** “How many locations would you want covered?” Use websites for a website-priced route. A supplied count becomes part of the offer without another question.\n- **Required access or delivery condition:** answer the buyer’s named requirement or obtain its exact missing fact. Recipients and action owners may differ. Secure access and actual delivery are verified before activation.\n- **Purchasing approval genuinely unresolved:** “Does anyone else need to approve this?” A stated partner/procurement requirement goes directly to O09/O17 without a new purpose question.\n\n**Tier selection:** website/technical-search only → Site Watch. Local/public visibility/contact → Watch. Supported standard CRM stalled/unworked-lead monitoring, including the ready HubSpot connection → Protect unless a genuinely deeper requirement needs Shield. A custom CRM ALWAYS → Shield. This does not establish the plan rule for every new off-the-shelf CRM connector. Multiple locations alone do not justify Shield. No-CRM does not exclude public checks or prove an unsupported internal connection.\n\n**New connector:** three business days after the customer’s IT supplies the required access. Preserve any actual access dependency and do not call connector completion active monitoring. The custom CRM connection is included in Shield, with no separate connector setup fee.\n\nA requested one-time project is I01, separate from a monitoring connector. Do not equate the standard connector timeframe with building, replacing or migrating an entire CRM. A material unsupported requirement goes F18/N01; a nonessential unknown does not prevent discussion of known supported scope.",
    "variants": [
      {
        "id": "system",
        "label": "System needed for the chosen check",
        "text": "Which customer system are you using?",
        "sourceStart": 311,
        "sourceEnd": 347
      },
      {
        "id": "threshold",
        "label": "Stalled-lead threshold not already specified and needed now",
        "text": "How long would you want a lead to sit without progressing before you’re notified?",
        "sourceStart": 550,
        "sourceEnd": 631
      },
      {
        "id": "quantity",
        "label": "Quoted quantity missing",
        "text": "How many locations would you want covered?",
        "sourceStart": 902,
        "sourceEnd": 944
      },
      {
        "id": "approval",
        "label": "Purchasing approval genuinely unresolved",
        "text": "Does anyone else need to approve this?",
        "sourceStart": 1328,
        "sourceEnd": 1366
      }
    ],
    "quotes": [
      "Which customer system are you using?",
      "How long would you want a lead to sit without progressing before you’re notified?",
      "How many locations would you want covered?",
      "Does anyone else need to approve this?"
    ]
  },
  "S06": {
    "id": "S06",
    "title": "One complete offer and purchase decision",
    "body": "Entry: the buyer wants the explained check and scope can provide it, or explicitly requests a recommendation. No separate demand to explain their reason to act.\n\n**Recommend:** “For [the check they want], I’d recommend [plan] for [quantity] at [total] a month. It covers [plain agreed scope].” Use the smallest sufficient plan. Custom CRM requires Shield, including the connection with no separate connector setup fee. Give a requested recommendation directly; that request alone is not a purchase acceptance.\n\nState actual setup/access, separate charges if any, material exclusions and billing/renewal/cancellation terms before commitment. Explain the three-business-day connector clock when relevant; do not imply instant activation or customer follow-up by AvertSignal. If a buyer asks for proof, use available relevant evidence through F11; proof is not an automatic step here.\n\n**Single ordinary invitation:** “Shall we get [plan] started at [monthly total]?” Pause. Yes → C01/C02 without a second invitation or unchanged-offer confirmation. Concern → its exact dependency and saved return. Not today after the invitation, reason unknown → “What’s keeping you from getting started today?” A stated reason goes directly to its branch. Final refusal → E01.\n\nAn informed explicit request to buy goes to C01 from anywhere. Material gaps still matter, but an accepted explanation, contextual usefulness yes or price inquiry is not itself acceptance of an unpresented offer.",
    "variants": [
      {
        "id": "recommend",
        "label": "Recommend",
        "text": "For [the check they want], I’d recommend [plan] for [quantity] at [total] a month. It covers [plain agreed scope].",
        "sourceStart": 178,
        "sourceEnd": 292
      },
      {
        "id": "invitation",
        "label": "Single ordinary invitation",
        "text": "Shall we get [plan] started at [monthly total]?",
        "sourceStart": 916,
        "sourceEnd": 963
      },
      {
        "id": "not-today",
        "label": "Single ordinary invitation",
        "text": "What’s keeping you from getting started today?",
        "sourceStart": 1146,
        "sourceEnd": 1192
      }
    ],
    "quotes": [
      "For [the check they want], I’d recommend [plan] for [quantity] at [total] a month. It covers [plain agreed scope].",
      "Shall we get [plan] started at [monthly total]?",
      "What’s keeping you from getting started today?"
    ]
  },
  "S07": {
    "id": "S07",
    "title": "Explain cost clearly and preserve scope",
    "body": "Canonical recurring USD prices: Site Watch $39/month per website; Watch $79/month first location + $39 each additional location; Protect $149 + $99 each additional location; Shield $299 + $219 each additional location. Use the current authoritative price at quoting/checkout and state applicable taxes/fees shown there. No invented annual offer, free month, recurring concession, or trial.\n\n**When quoting or clarifying established fit:** “[Plan] for [quantity] is [total] a month. That includes [plain scope], with [material terms].” A price answer does not carry an automatic purchase ask. Use the S06 invitation only once buyer-recognized value, fit and material commercial facts are clear; an informed explicit request to buy can proceed to C01. Use the actual recurring frequency, any separate charge, and material renewal/cancellation condition. Do not repeat a total, terms review or purchase ask just completed in S06. A material unknown must be checked, not hidden in a placeholder.\n\n**Early “how much?”:** answer directly with the applicable known price, or the four list prices if no scope is known and they want the range. Then resume the next unsatisfied saved question. A plan-difference question may replace it only if that is now the relevant unresolved fit point; never ask both by default. Return to the exact S03/S04/S05/S06 context; do not withhold pricing until a questionnaire is complete. If they explicitly want to buy, use C01 and only remaining material checks.\n\n**Price objection:** O04/O05/O06. **More locations/sites or new scope:** recalculate. **Quote different from checkout:** stop and verify, never explain away the difference. **Buyer selects higher tier:** verify the need; do not recommend higher merely because they will pay.",
    "variants": [
      {
        "id": "quote",
        "label": "When quoting or clarifying established fit",
        "text": "[Plan] for [quantity] is [total] a month. That includes [plain scope], with [material terms].",
        "sourceStart": 440,
        "sourceEnd": 533
      }
    ],
    "quotes": [
      "[Plan] for [quantity] is [total] a month. That includes [plain scope], with [material terms]."
    ]
  },
  "P01": {
    "id": "P01",
    "title": "Provider comparison without restarting discovery",
    "body": "A provider mention is usually context for S04, not an objection that creates another question. Current awareness is already owned by S03; there is no provider-notification question here.\n\n**Replacement concern:** “Your [named provider] keeps handling [their work]. AvertSignal adds the agreed check and findings they can use.” Answer that boundary once.\n\n**Specific duplication/comparison question:** compare the named check, evidence and responsibilities. Separate evidence or reassurance can be wanted even when checks overlap. If no check has yet been explained, use S04’s one explanation and judgment; do not print a second judgment here. If usefulness was accepted, do not test it again. If the buyer wants no addition, exit.\n\n**One or several tools:** compare actual required result, not tool count. **Unknown function:** “I don’t know that function well enough to compare it fairly. We can check [specific difference].” Wanted research → N01. Provider fixes reported issues does not prove no monitoring.\n\nExact saved return always controls. Provider input/access → P02; contract → O17; informed buyer → C01. Challenge only genuinely incompatible facts, not a newly supplied provider preference.",
    "variants": [
      {
        "id": "replacement",
        "label": "Replacement concern",
        "text": "Your [named provider] keeps handling [their work]. AvertSignal adds the agreed check and findings they can use.",
        "sourceStart": 214,
        "sourceEnd": 325
      },
      {
        "id": "unknown-function",
        "label": "Unknown function",
        "text": "I don’t know that function well enough to compare it fairly. We can check [specific difference].",
        "sourceStart": 829,
        "sourceEnd": 925
      }
    ],
    "quotes": [
      "Your [named provider] keeps handling [their work]. AvertSignal adds the agreed check and findings they can use.",
      "I don’t know that function well enough to compare it fairly. We can check [specific difference]."
    ]
  },
  "P02": {
    "id": "P02",
    "title": "I need to check with my provider",
    "body": "**Reason unknown:** “What would you like their input on?” Otherwise use the stated reason.\n\n**Duplication:** “We can send them [specific check and example finding] so you can compare it with what they already provide.” Agree the reviewer and wanted next step. No invented approval gate.\n\n**Relationship concern:** “Your [named provider] keeps handling [their work]. Would you like to confirm how they’d use the findings?” Only if unresolved; explain the actual evidence once, then confirm and return.\n\n**Contract:** O17/N01; reassurance cannot clear a restriction. **Technical access:** exact system, permissions and authorizer → F13/F18/N01. No compatibility/date promise. **Equivalent coverage:** P01; no wanted addition → E02.\n\n**Another opinion wanted:** respect it and provide the useful material, without forcing a meeting. Needed answer → N01 with question, owner and timing. Resolved → next unsatisfied saved substep. A planned conversation is not approval.",
    "variants": [
      {
        "id": "reason-unknown",
        "label": "Reason unknown",
        "text": "What would you like their input on?",
        "sourceStart": 21,
        "sourceEnd": 56
      },
      {
        "id": "duplication",
        "label": "Duplication",
        "text": "We can send them [specific check and example finding] so you can compare it with what they already provide.",
        "sourceStart": 110,
        "sourceEnd": 217
      },
      {
        "id": "relationship",
        "label": "Relationship concern",
        "text": "Your [named provider] keeps handling [their work]. Would you like to confirm how they’d use the findings?",
        "sourceStart": 315,
        "sourceEnd": 420
      }
    ],
    "quotes": [
      "What would you like their input on?",
      "We can send them [specific check and example finding] so you can compare it with what they already provide.",
      "Your [named provider] keeps handling [their work]. Would you like to confirm how they’d use the findings?"
    ]
  },
  "P03": {
    "id": "P03",
    "title": "Another tool DIY team or competitor",
    "body": "**Comparison specified:** answer it. **Current use unknown:** “What are you using [named tool/team] to check today?” Clarify only the missing scope, cost, trust or responsibility difference.\n\nCompare like-for-like results and ongoing work. State the concrete difference: “AvertSignal would add [specific check or evidence], for [full price].” This card has no separate usefulness judgment. A genuinely undecided addition goes to S04’s one wanted-check decision; an already wanted addition stays settled while the actual comparison concern is addressed.\n\nEquivalent results and no wanted addition → E02. Unknown function → N01. Keep useful tools/providers; no unsupported uniqueness claim or cancellation recommendation.",
    "variants": [
      {
        "id": "current-use",
        "label": "Current use unknown",
        "text": "What are you using [named tool/team] to check today?",
        "sourceStart": 63,
        "sourceEnd": 115
      },
      {
        "id": "comparison",
        "label": "Current use unknown",
        "text": "AvertSignal would add [specific check or evidence], for [full price].",
        "sourceStart": 272,
        "sourceEnd": 341
      }
    ],
    "quotes": [
      "What are you using [named tool/team] to check today?",
      "AvertSignal would add [specific check or evidence], for [full price]."
    ]
  },
  "O01": {
    "id": "O01",
    "title": "Not interested or unclear relevance",
    "body": "**If the buyer already declined S04’s wanted-check decision or repeats a refusal:** E01/E02; do not restart usefulness. **One clarification of relevance not already decided, only while still welcome:** “We check [named relevant step] and alert [person] if we detect [specific issue]. Would that be useful here?” Use a relevant supported example; do not force a choice between bad coverage and failure to understand.\n\n**Yes to that specific use:** the wanted-check decision is satisfied; proceed to missing fit in S05. The explained and wanted check makes a prior generic awareness question unnecessary; do not return to S03 simply because it was once pending. **Already gets what they need:** P01 only if they want to compare; otherwise E02. **Bad time:** O08. **No useful relevance known:** respect the answer rather than start a questionnaire.\n\n**One clarification total:** no second usefulness question or more direct pass. A repeated refusal, “stop,” “don’t call,” or clear wish to end → E01 immediately, without isolation or reclose.",
    "variants": [
      {
        "id": "relevance",
        "label": "One clarification of relevance not already decided, only while still welcome",
        "text": "We check [named relevant step] and alert [person] if we detect [specific issue]. Would that be useful here?",
        "sourceStart": 203,
        "sourceEnd": 310
      }
    ],
    "quotes": [
      "We check [named relevant step] and alert [person] if we detect [specific issue]. Would that be useful here?"
    ]
  },
  "O02": {
    "id": "O02",
    "title": "“I need to think about it”",
    "body": "**First pass:** “Of course. What's the part you're still weighing?”\n\nPrice → O04; timing → O07; proof → O10; provider → P02; another person → O09; fit → S05. **Still vague and engaged:** “Is it the usefulness, the cost, or confidence in us?” Use a short relevant choice, not a list of every possible objection.\n\nOnce specific, address it on the relevant card; use decision-stage isolation only if appropriate. If resolution is still unclear, “Does that answer the part you were weighing?” Then exact return. If the buyer simply wants time after questions are answered, respect that. “When would you like to revisit the decision?” → N01 if welcomed; E03 if not. No invented claim that all thinking is a disguised objection.",
    "variants": [
      {
        "id": "first-pass",
        "label": "First pass",
        "text": "Of course. What's the part you're still weighing?",
        "sourceStart": 17,
        "sourceEnd": 66
      },
      {
        "id": "still-vague",
        "label": "Still vague and engaged",
        "text": "Is it the usefulness, the cost, or confidence in us?",
        "sourceStart": 188,
        "sourceEnd": 240
      },
      {
        "id": "confirm",
        "label": "Still vague and engaged",
        "text": "Does that answer the part you were weighing?",
        "sourceStart": 443,
        "sourceEnd": 487
      },
      {
        "id": "revisit",
        "label": "Still vague and engaged",
        "text": "When would you like to revisit the decision?",
        "sourceStart": 584,
        "sourceEnd": 628
      }
    ],
    "quotes": [
      "Of course. What's the part you're still weighing?",
      "Is it the usefulness, the cost, or confidence in us?",
      "Does that answer the part you were weighing?",
      "When would you like to revisit the decision?"
    ]
  },
  "O03": {
    "id": "O03",
    "title": "Working systems or existing coverage",
    "body": "**No past failure:** “You don’t need a past failure for monitoring to be useful. The check tells you when [specific monitored condition] changes.” Do not imply a defect or make them defend healthy systems.\n\n**Already covered:** use P01 only for the actual comparison question. Separate checks/evidence can still offer wanted assurance, but no wanted addition is a valid exit.\n\nThis card adds no detection or usefulness question. If S04’s wanted-check decision has not happened, return to that one decision after answering the actual concern. If it is settled, continue from the next unresolved point. A new fact about coverage updates scope; it does not automatically invalidate the buyer’s wish for an independent check.",
    "variants": [
      {
        "id": "no-past-failure",
        "label": "No past failure",
        "text": "You don’t need a past failure for monitoring to be useful. The check tells you when [specific monitored condition] changes.",
        "sourceStart": 22,
        "sourceEnd": 145
      }
    ],
    "quotes": [
      "You don’t need a past failure for monitoring to be useful. The check tells you when [specific monitored condition] changes."
    ]
  },
  "O04": {
    "id": "O04",
    "title": "Identify an unknown price concern once",
    "body": "**Concern truly unspecified:** “Is the monthly cost the issue, or are you unsure you’d use what it gives you?” This classification happens once. A stated cap, comparison, missing feature or concern goes directly to its matching answer; no second amount-versus-value question.\n\n**Value:** address the actual missing connection between the wanted check/evidence and the price. Use their confirmed context, not invented losses. Do not repeat the S04 usefulness decision or the same accepted example.\n\n**Comparison:** P03. **Stated cash cap:** O05 directly. **Unneeded scope:** O06. **Trust/proof:** O10/F11. **ROI guarantee:** “I can’t promise a dollar return. You’d be paying [total] for [specific agreed check and evidence].” F10 if a guarantee is essential; no invented saved-lead arithmetic.\n\nAt a buying decision, if other concerns remain unknown, isolate them once. Respond substantively, then return to the next unsatisfied saved decision. The firmer unresolved-concern question is justified only after a changed state or new answer, not simply because the first clarification did not produce a sale.",
    "variants": [
      {
        "id": "unspecified-price",
        "label": "Concern truly unspecified",
        "text": "Is the monthly cost the issue, or are you unsure you’d use what it gives you?",
        "sourceStart": 32,
        "sourceEnd": 109
      },
      {
        "id": "roi-guarantee",
        "label": "ROI guarantee",
        "text": "I can’t promise a dollar return. You’d be paying [total] for [specific agreed check and evidence].",
        "sourceStart": 625,
        "sourceEnd": 723
      }
    ],
    "quotes": [
      "Is the monthly cost the issue, or are you unsure you’d use what it gives you?",
      "I can’t promise a dollar return. You’d be paying [total] for [specific agreed check and evidence]."
    ]
  },
  "O05": {
    "id": "O05",
    "title": "Budget already given or genuinely unclear",
    "body": "**Firm cap already stated:** use it immediately to compare the smallest sufficient scope. Do not reclassify price/value or ask whether it is firm. Custom CRM scope remains Shield; an insufficient lower tier is not an option.\n\n**Only “not budgeted” is known:** “Is there a spending limit we need to work within?” This seeks an actionable amount/constraint, not a second value test. If the buyer says the issue is approval or timing instead, follow that fact.\n\nSufficient approved smaller scope → O06 with actual removed scope and new total. No sufficient option at the cap → E03. Real future budget date/approval already supplied → N01 using it, without asking why or when again. Same recurring scope for less requires owner approval; no promised exception.\n\nResolve the actual constraint, then return to the saved decision. Do not print an additional purchase invitation here; S06 owns it.",
    "variants": [
      {
        "id": "budget-limit",
        "label": "Only “not budgeted” is known",
        "text": "Is there a spending limit we need to work within?",
        "sourceStart": 261,
        "sourceEnd": 310
      }
    ],
    "quotes": [
      "Is there a spending limit we need to work within?"
    ]
  },
  "O06": {
    "id": "O06",
    "title": "Cheaper plan discount or correct scope",
    "body": "**Wants a lower cost plan:** “Let me check whether a lower plan still covers [stated priority].” The rep checks the plans; do not ask the buyer to design unfamiliar coverage.\n\n**Lower plan sufficient:** state what stays, what is removed and the revised full total. Confirm the buyer wants that scope, then resume the saved parent concern or stage. A changed plan invalidates the old quote. Reclose only at a saved purchase-ready decision.\n\n**Primary need would be lost:** “The lower plan doesn’t check [required thing]. That’s what you want checked, so I wouldn’t recommend it for this.” Correct scope remains; O05/E03 if unaffordable.\n\n**Same recurring scope for less:** “I don’t have authority to change that monthly price. We can keep this scope at [total], or I can request an exception without promising approval.” OWNER APPROVAL REQUIRED; request only if wanted. No invented promotion.\n\n**Only asks if price is negotiable:** “That’s the current price for [scope].” Answer directly; if accepted, return. At a buying decision only, clarify any other unresolved concern before the invitation. Required concession → authorized review or E03. One-time I02 concessions never apply automatically to subscriptions.",
    "variants": [
      {
        "id": "lower-plan",
        "label": "Wants a lower cost plan",
        "text": "Let me check whether a lower plan still covers [stated priority].",
        "sourceStart": 30,
        "sourceEnd": 95
      },
      {
        "id": "required-scope",
        "label": "Primary need would be lost",
        "text": "The lower plan doesn’t check [required thing]. That’s what you want checked, so I wouldn’t recommend it for this.",
        "sourceStart": 473,
        "sourceEnd": 586
      },
      {
        "id": "same-scope-discount",
        "label": "Same recurring scope for less",
        "text": "I don’t have authority to change that monthly price. We can keep this scope at [total], or I can request an exception without promising approval.",
        "sourceStart": 673,
        "sourceEnd": 818
      },
      {
        "id": "negotiability",
        "label": "Only asks if price is negotiable",
        "text": "That’s the current price for [scope].",
        "sourceStart": 932,
        "sourceEnd": 969
      }
    ],
    "quotes": [
      "Let me check whether a lower plan still covers [stated priority].",
      "The lower plan doesn’t check [required thing]. That’s what you want checked, so I wouldn’t recommend it for this.",
      "I don’t have authority to change that monthly price. We can keep this scope at [total], or I can request an exception without promising approval.",
      "That’s the current price for [scope]."
    ]
  },
  "O07": {
    "id": "O07",
    "title": "Not today or not right now",
    "body": "**After a purchase invitation, reason unknown:** “What’s keeping you from getting started today?” Reuse a stated reason; never ask again. This wording is not an early-call question.\n\n**Early “not now”:** explicit busy/later → O08. If they mean no relevance and remain willing, O01’s one clarification; final refusal → E01. Do not presume a purchase decision.\n\n**Real dependency:** resolve what can be settled; otherwise N01 with exact dependency, owner and timing. **Trust/price/provider/authority:** corresponding card. **No urgent failure:** use the stated timing preference or dependency. Do not ask now-versus-later again after “not today,” or retest usefulness after an ordinary offer. A genuinely changed wanted scope updates that fact; no fabricated deadline.\n\n**Still vague and engaged after a buying invitation:** “What would need to be different for this to make sense?” Ask only once and follow the answer. A settled concern returns to the exact buying decision; a preference for later gets an optional specific next step or E03. No immediate reclose after they chose later.",
    "variants": [
      {
        "id": "not-today",
        "label": "After a purchase invitation, reason unknown",
        "text": "What’s keeping you from getting started today?",
        "sourceStart": 50,
        "sourceEnd": 96
      },
      {
        "id": "still-vague",
        "label": "Still vague and engaged after a buying invitation",
        "text": "What would need to be different for this to make sense?",
        "sourceStart": 824,
        "sourceEnd": 879
      }
    ],
    "quotes": [
      "What’s keeping you from getting started today?",
      "What would need to be different for this to make sense?"
    ]
  },
  "O08": {
    "id": "O08",
    "title": "Use the requested callback instead of rediscovering it",
    "body": "**Time and zone supplied:** “Of course. We’ll pick up with [unfinished point].” Use the supplied time to check/save the callback. Clarify only a genuinely missing date/zone or actual conflict, never ask what time is better after a suitable time was given.\n\n**Callback wanted but no time given:** “Of course. When would you like me to call?” → N01. At the opening there may be no unfinished substantive topic to name.\n\n**Genuinely ambiguous pause, still willing to talk:** “Would you rather pick this up later, or is there a question I can answer now?” Do not use this after an explicit departure/callback request.\n\nPreserve facts, concerns, quote state and exact unfinished decision. A proposed time is not a saved booking. No future contact wanted → E03/E01. Respect a close-stage interruption just as an early one.",
    "variants": [
      {
        "id": "supplied-time",
        "label": "Time and zone supplied",
        "text": "Of course. We’ll pick up with [unfinished point].",
        "sourceStart": 29,
        "sourceEnd": 78
      },
      {
        "id": "missing-time",
        "label": "Callback wanted but no time given",
        "text": "Of course. When would you like me to call?",
        "sourceStart": 297,
        "sourceEnd": 339
      },
      {
        "id": "ambiguous-pause",
        "label": "Genuinely ambiguous pause, still willing to talk",
        "text": "Would you rather pick this up later, or is there a question I can answer now?",
        "sourceStart": 473,
        "sourceEnd": 550
      }
    ],
    "quotes": [
      "Of course. We’ll pick up with [unfinished point].",
      "Of course. When would you like me to call?",
      "Would you rather pick this up later, or is there a question I can answer now?"
    ]
  },
  "O09": {
    "id": "O09",
    "title": "Use the stated approval or opinion dependency",
    "body": "**Required approver/purpose supplied:** act on it. “I can put [the requested scope, price or evidence] together for [named person].” Use the requested delivery/review mode; do not ask what they need to weigh in on or force a meeting.\n\n**Another person mentioned without a role or purpose:** “What would you like [named person] to weigh in on?” This resolves only the missing dependency. If required approval is known but the reviewer is not, identify the reviewer rather than asking their purpose.\n\nA named price concern → O04; explanation of the recommendation → the exact S06 scope/price fact; a genuinely unknown opinion request gets the one purpose clarification above. The buyer may want an opinion even when able to decide alone. Respect it. A planned conversation or reportedly unopposed partner is not actual required approval. Once the dependency is genuinely resolved, continue from the next unsatisfied saved decision; no repeated authority screen or extra close.",
    "variants": [
      {
        "id": "known-approver",
        "label": "Required approver/purpose supplied",
        "text": "I can put [the requested scope, price or evidence] together for [named person].",
        "sourceStart": 52,
        "sourceEnd": 131
      },
      {
        "id": "unknown-purpose",
        "label": "Another person mentioned without a role or purpose",
        "text": "What would you like [named person] to weigh in on?",
        "sourceStart": 292,
        "sourceEnd": 342
      }
    ],
    "quotes": [
      "I can put [the requested scope, price or evidence] together for [named person].",
      "What would you like [named person] to weigh in on?"
    ]
  },
  "O10": {
    "id": "O10",
    "title": "Trust, legitimacy, references and proof",
    "body": "**Specific demo/reference/security request:** answer or route that request first; no broad discovery question. **If proof shown earlier was not enough:** “What would you still need to see?” **Concern still unspecified:** “What would help you feel sure about this?” Do not replay the same example as if it were new evidence.\n\n**Demo:** F11. **Legitimacy:** offer official company pages, contact channel and current terms; let the buyer inspect them independently. **Customer reference:** use only an approved, permission-cleared reference or published authorized case study; never invent a client, imply unapproved endorsement, or disclose private contact details. No reference available → say so and offer relevant verified proof instead.\n\n**Proof of their exact integration:** F18; simulations aren't support evidence. **Specific security concern:** O11. Isolate other blockers; present the exact evidence requested, then “Does that settle [specific concern]?” If no, identify missing evidence and N01. If yes, return to precise stage or purchase decision. A second assurance without new evidence is not a resolution.",
    "variants": [
      {
        "id": "more-proof",
        "label": "If proof shown earlier was not enough",
        "text": "What would you still need to see?",
        "sourceStart": 155,
        "sourceEnd": 188
      },
      {
        "id": "unspecified-trust",
        "label": "Concern still unspecified",
        "text": "What would help you feel sure about this?",
        "sourceStart": 222,
        "sourceEnd": 263
      },
      {
        "id": "confirm",
        "label": "Specific security concern",
        "text": "Does that settle [specific concern]?",
        "sourceStart": 924,
        "sourceEnd": 960
      }
    ],
    "quotes": [
      "What would you still need to see?",
      "What would help you feel sure about this?",
      "Does that settle [specific concern]?"
    ]
  },
  "O11": {
    "id": "O11",
    "title": "Security, permissions, stored data or change authority",
    "body": "**Specific access/data/control question:** answer that question directly. **Vague security concern only:** “What worries you most: what we can see, what we keep, or what we can change?”\n\n**Access:** F13. **Retention/copying customer data:** F14. **Can AvertSignal make changes:** “We need to review the actual connection and permissions before I tell you what it can change.” Review exact authorized controls; never claim blanket read-only, automatic repair or unrestricted authority.\n\nIsolate other blockers; provide current documented evidence and let the customer review. “Does that answer your concern about [specific permission/data/control]?” Accepted → unwind to prior concern or exact stage. Open security review → N01; no supported acceptable configuration → E02. The buyer's willingness to pay never removes this unresolved material dependency.",
    "variants": [
      {
        "id": "vague-security",
        "label": "Vague security concern only",
        "text": "What worries you most: what we can see, what we keep, or what we can change?",
        "sourceStart": 108,
        "sourceEnd": 184
      },
      {
        "id": "change-authority",
        "label": "Can AvertSignal make changes",
        "text": "We need to review the actual connection and permissions before I tell you what it can change.",
        "sourceStart": 281,
        "sourceEnd": 374
      },
      {
        "id": "confirm",
        "label": "Can AvertSignal make changes",
        "text": "Does that answer your concern about [specific permission/data/control]?",
        "sourceStart": 576,
        "sourceEnd": 647
      }
    ],
    "quotes": [
      "What worries you most: what we can see, what we keep, or what we can change?",
      "We need to review the actual connection and permissions before I tell you what it can change.",
      "Does that answer your concern about [specific permission/data/control]?"
    ]
  },
  "O12": {
    "id": "O12",
    "title": "Trial request",
    "body": "**Availability question:** “You can apply for a 14-day free trial.” Then, only if the goal is unknown: “What would you want to test?” Answer the trial question before asking discovery.\n\n**Application/terms:** F19. Verify eligibility and the actual approved offer, scope, start, billing and cancellation terms before acceptance. Applying is not approval or activation. Unknown/ineligible → say so, with N01 or relevant proof if wanted; no invented free account.\n\n**A demo answers their goal and they want to see it:** F11. **Live proof needed:** keep that requirement open. Do not replace a requested trial with a mandatory demo.\n\nAfter the evidence exists, confirm only what remains unclear: “Has that answered what you wanted to test?” Then exact return. A future trial cannot be represented as completed proof or agreement to buy.",
    "variants": [
      {
        "id": "trial-application",
        "label": "Availability question",
        "text": "You can apply for a 14-day free trial.",
        "sourceStart": 28,
        "sourceEnd": 66
      },
      {
        "id": "trial-goal",
        "label": "Availability question",
        "text": "What would you want to test?",
        "sourceStart": 104,
        "sourceEnd": 132
      },
      {
        "id": "confirm",
        "label": "Live proof needed",
        "text": "Has that answered what you wanted to test?",
        "sourceStart": 693,
        "sourceEnd": 735
      }
    ],
    "quotes": [
      "You can apply for a 14-day free trial.",
      "What would you want to test?",
      "Has that answered what you wanted to test?"
    ]
  },
  "O13": {
    "id": "O13",
    "title": "Send me information",
    "body": "**Specific item requested:** agree the exact item and send through the approved route; no clarification question needed. **Request is general:** “Sure. Would a short overview help, or is there a specific question you want answered?”\n\nIf they welcome a brief answer now, give it. If they want material only, respect that. Confirm recipient/address and permission before sending. Do not require a call or a buying decision in exchange for information.\n\n**Follow-up wanted:** agree its purpose and preferred timing → N01. **No follow-up wanted:** E03. **Concern answered now:** exact saved return. A sent state needs an actual send result, not an intention. Information sent is not an appointment or purchase.",
    "variants": [
      {
        "id": "general-information",
        "label": "Request is general",
        "text": "Sure. Would a short overview help, or is there a specific question you want answered?",
        "sourceStart": 146,
        "sourceEnd": 231
      }
    ],
    "quotes": [
      "Sure. Would a short overview help, or is there a specific question you want answered?"
    ]
  },
  "O14": {
    "id": "O14",
    "title": "Setup effort or owner time",
    "body": "**Setup not yet explained:** “For [scope], setup means [actual steps], handled by [person].” Verify the process before giving this line. Unknown material step → F12/F13/F18 and a named check; do not ask the buyer to diagnose a process they have not heard.\n\n**Concern still unclear after explanation:** “Which part concerns you?” If the buyer already named the difficult step, address it directly.\n\n**Time:** explain actual effort only; no universal duration or zero-effort promise. **Account control:** identify the authorized person and secure connection step → F13/N01. **Compatibility:** F18. **Training/workload:** verify the actual workflow. **Busy now:** O08.\n\nAfter answering the specific concern, “Does that address the setup step you were worried about?” if needed. Settled → exact return. Unresolved → named technical/onboarding review. Payment is not proof of setup or active coverage.",
    "variants": [
      {
        "id": "setup",
        "label": "Setup not yet explained",
        "text": "For [scope], setup means [actual steps], handled by [person].",
        "sourceStart": 30,
        "sourceEnd": 91
      },
      {
        "id": "specific-concern",
        "label": "Concern still unclear after explanation",
        "text": "Which part concerns you?",
        "sourceStart": 303,
        "sourceEnd": 327
      },
      {
        "id": "confirm",
        "label": "Busy now",
        "text": "Does that address the setup step you were worried about?",
        "sourceStart": 706,
        "sourceEnd": 762
      }
    ],
    "quotes": [
      "For [scope], setup means [actual steps], handled by [person].",
      "Which part concerns you?",
      "Does that address the setup step you were worried about?"
    ]
  },
  "O15": {
    "id": "O15",
    "title": "Checkout later / link sent but not completed",
    "body": "**Unexplained delay only:** “Is there a question about checkout I can help with?” If they already said busy or later, use O08 without asking them to explain again.\n\n**Link/page/payment failure:** C03. **Terms review:** O17. **Price/trust/new concern:** corresponding card, preserve quote and return point. **Actual time interruption:** O08. **No change needed, still engaged:** “Would you like to finish it while we're here?” No → respect later choice and, if wanted, N01. Don't mark paid because the link was opened or because the buyer says “I'll do it.” Confirm → exact checkout stage, not back to discovery.",
    "variants": [
      {
        "id": "checkout-question",
        "label": "Unexplained delay only",
        "text": "Is there a question about checkout I can help with?",
        "sourceStart": 29,
        "sourceEnd": 80
      },
      {
        "id": "finish-checkout",
        "label": "No change needed, still engaged",
        "text": "Would you like to finish it while we're here?",
        "sourceStart": 379,
        "sourceEnd": 424
      }
    ],
    "quotes": [
      "Is there a question about checkout I can help with?",
      "Would you like to finish it while we're here?"
    ]
  },
  "O16": {
    "id": "O16",
    "title": "Size referrals no CRM or no website",
    "body": "**Too small:** “We can focus on the one check that matters here.” Use the existing relevant check; no new usefulness question. **Large/internal team:** size alone does not require Shield; a custom CRM does. Answer the actual scope/comparison point through S05/P01.\n\n**Referral-led and contact channel genuinely unknown:** “When someone gets referred, how do they contact or check you out?” This identifies a specific possible public scope; it does not repeat detection. If the channel was already named, use it.\n\n**No CRM:** do not ask a generic process question merely to keep discovery going. Use any wanted supported public/contact check already named. A buyer-requested internal non-CRM check gets specific compatibility review; no assumption of fit or no-fit.\n\n**No website:** a wanted local-presence check may still fit Watch. Website creation is offered only when requested/needed as a separate project, not a compulsory sale.\n\nIf no addition is wanted or no essential scope can be provided, exit. These are alternatives, not five explanations to recite.",
    "variants": [
      {
        "id": "small-business",
        "label": "Too small",
        "text": "We can focus on the one check that matters here.",
        "sourceStart": 16,
        "sourceEnd": 64
      },
      {
        "id": "referral-channel",
        "label": "Referral-led and contact channel genuinely unknown",
        "text": "When someone gets referred, how do they contact or check you out?",
        "sourceStart": 323,
        "sourceEnd": 388
      }
    ],
    "quotes": [
      "We can focus on the one check that matters here.",
      "When someone gets referred, how do they contact or check you out?"
    ]
  },
  "O17": {
    "id": "O17",
    "title": "Procurement, legal, contract, invoice, PO or cancellation",
    "body": "**A specific invoice, PO or cancellation question gets its factual answer first (F20 or verified billing details). If a process requirement remains unknown:** “What does your process need before you can approve this?” Reuse the process already established at S05 and the terms reviewed at S06/S07; a newly raised condition stays open.\n\n**Invoice/PO/vendor setup:** record exact required document, paying entity and reviewer. Verify whether the billing workflow supports it. Do not promise invoicing or bypass procurement. **Legal/provider restriction:** identify clause or approval; keep it open until satisfied. **Contract/cancellation/refund concern:** F20; use current checkout/account terms and specific agreement. Public terms alone do not prove cancel-anytime or refund eligibility.\n\nIsolate other blockers and supply approved material; reviewer's acceptance must be real. “Has [named requirement] been cleared?” Yes → resume the parent concern or saved stage; only at the purchase decision complete remaining checks then C01. No → N01. A scheduled review is not legal approval, and an interested contact is not purchasing authority.",
    "variants": [
      {
        "id": "unknown-process",
        "label": "A specific invoice, PO or cancellation question gets its factual answer first (F20 or verified billing details). If a process requirement remains unknown",
        "text": "What does your process need before you can approve this?",
        "sourceStart": 160,
        "sourceEnd": 216
      },
      {
        "id": "requirement-cleared",
        "label": "Contract/cancellation/refund concern",
        "text": "Has [named requirement] been cleared?",
        "sourceStart": 880,
        "sourceEnd": 917
      }
    ],
    "quotes": [
      "What does your process need before you can approve this?",
      "Has [named requirement] been cleared?"
    ]
  },
  "O18": {
    "id": "O18",
    "title": "Act on an informed request to buy",
    "body": "An explicit informed buying request goes straight to C01. Confirm only a changed or missing material fact. There is no default “Shall we go ahead?” invitation here after the buyer has already chosen to buy.\n\nIf the buyer asks for a recommendation rather than purchasing, S06 answers that request and holds the single offer/decision. A polite interest statement is not a buying request. Custom CRM requires Shield even if the buyer asks for Protect. Known HubSpot support is stated directly; a genuine essential unknown stays open. No required meeting, demonstration, founder story or rep attribution.",
    "variants": [],
    "quotes": []
  },
  "G01": {
    "id": "G01",
    "title": "Identify responsibility once",
    "body": "**Name/role supplied:** “Is [verified name/role] available?” → G02/G03. **Person says “I handle that”:** use that role fact and give the service/relevance they have not heard; no automatic decision-versus-coordinator screen.\n\n**Responsibility genuinely unknown:** “Who looks after the website and how new customer requests are handled?” A named role goes G02/G03; still unknown → G04. Do not ask the same routing question under a different card label.\n\nA later actual purchase-approval fact is distinct from operational responsibility; obtain it only if needed for commitment. Be honest about the sales purpose and work respectfully through a coordinator.",
    "variants": [
      {
        "id": "known-role",
        "label": "Name/role supplied",
        "text": "Is [verified name/role] available?",
        "sourceStart": 25,
        "sourceEnd": 59
      },
      {
        "id": "unknown-role",
        "label": "Responsibility genuinely unknown",
        "text": "Who looks after the website and how new customer requests are handled?",
        "sourceStart": 265,
        "sourceEnd": 335
      }
    ],
    "quotes": [
      "Is [verified name/role] available?",
      "Who looks after the website and how new customer requests are handled?"
    ]
  },
  "G02": {
    "id": "G02",
    "title": "Transfer, reason for call and sales-call honesty",
    "body": "**Transfer request:** “Could you put me through to [verified name/role], please?” Connected → introduce yourself honestly with S01; no pretended prior conversation or personal relationship.\n\n**“What's this about?”:** “We help businesses catch problems with how customers find them, contact them or get a reply. I’m calling to see whether that would be useful here.” Then ask for the correct role, not confidential details.\n\n**“Is this a sales call?”:** “Yes. I'm calling to see whether AvertSignal's monitoring would be useful for the business.” Continue only if welcome. Transfer unavailable → G03. No solicitation/final refusal → E01.",
    "variants": [
      {
        "id": "transfer",
        "label": "Transfer request",
        "text": "Could you put me through to [verified name/role], please?",
        "sourceStart": 23,
        "sourceEnd": 80
      },
      {
        "id": "reason",
        "label": "“What's this about?”",
        "text": "We help businesses catch problems with how customers find them, contact them or get a reply. I’m calling to see whether that would be useful here.",
        "sourceStart": 218,
        "sourceEnd": 364
      },
      {
        "id": "sales-honesty",
        "label": "“Is this a sales call?”",
        "text": "Yes. I'm calling to see whether AvertSignal's monitoring would be useful for the business.",
        "sourceStart": 454,
        "sourceEnd": 544
      }
    ],
    "quotes": [
      "Could you put me through to [verified name/role], please?",
      "We help businesses catch problems with how customers find them, contact them or get a reply. I’m calling to see whether that would be useful here.",
      "Yes. I'm calling to see whether AvertSignal's monitoring would be useful for the business."
    ]
  },
  "G03": {
    "id": "G03",
    "title": "Use the supplied contact route",
    "body": "**Recipient/channel already supplied:** use those facts. If the gatekeeper says “Dan is out; email him at [address],” record Dan and that address and send only the agreed material through the approved route. Do not ask how to reach him or who to address it to again.\n\n**Contact route genuinely unknown:** “What’s the best way to reach [named person] about this?” An email answer without a recipient/address creates only that missing-field question. A callback answer uses the supplied availability/time zone through N01; proposed by a third party is not a confirmed booking.\n\nVerify recipient accuracy and sending permission as required without repeating already clear facts. General inbox only → G04. No invented consent for repeated contact; a contact address establishes neither buying authority nor product fit.",
    "variants": [
      {
        "id": "unknown-contact-route",
        "label": "Contact route genuinely unknown",
        "text": "What’s the best way to reach [named person] about this?",
        "sourceStart": 306,
        "sourceEnd": 361
      }
    ],
    "quotes": [
      "What’s the best way to reach [named person] about this?"
    ]
  },
  "G04": {
    "id": "G04",
    "title": "Ownership still unknown / general-inbox exit",
    "body": "**Say:** “Thanks. I can send a short explanation to the address you've given for the person who handles this.” Only say this if sending was requested/approved and a valid recipient exists.\n\nRecord routing unresolved and the permitted next action. No verified email/action permission → “Thanks for your help.” End. General inbox delivery is not a qualified opportunity, scheduled meeting, or owner interest. Explicit stop/no solicitation → E01.",
    "variants": [
      {
        "id": "approved-send",
        "label": "Say",
        "text": "Thanks. I can send a short explanation to the address you've given for the person who handles this.",
        "sourceStart": 10,
        "sourceEnd": 109
      },
      {
        "id": "no-send",
        "label": "Say",
        "text": "Thanks for your help.",
        "sourceStart": 286,
        "sourceEnd": 307
      }
    ],
    "quotes": [
      "Thanks. I can send a short explanation to the address you've given for the person who handles this.",
      "Thanks for your help."
    ]
  },
  "F01": {
    "id": "F01",
    "title": "What is this, “protect,” or “the whole way”?",
    "body": "“We watch for problems that can get in the way when customers try to find you, reach you or get a reply. We help you see what needs attention and who should handle it.”\n\nWhole-way question: “That could mean your website, your Google listing, or what happens after someone gets in touch. We agree on what we can watch in your setup.” Never imply every step is visible or that “protection” means insurance or reimbursement. [Coverage](https://avertsignal.com/what-we-protect/)",
    "variants": [
      {
        "id": "definition",
        "label": "definition",
        "text": "We watch for problems that can get in the way when customers try to find you, reach you or get a reply. We help you see what needs attention and who should handle it.",
        "sourceStart": 1,
        "sourceEnd": 167
      },
      {
        "id": "whole-way",
        "label": "whole-way",
        "text": "That could mean your website, your Google listing, or what happens after someone gets in touch. We agree on what we can watch in your setup.",
        "sourceStart": 191,
        "sourceEnd": 331
      }
    ],
    "quotes": [
      "We watch for problems that can get in the way when customers try to find you, reach you or get a reply. We help you see what needs attention and who should handle it.",
      "That could mean your website, your Google listing, or what happens after someone gets in touch. We agree on what we can watch in your setup."
    ]
  },
  "F02": {
    "id": "F02",
    "title": "Did you find something wrong? / never had a problem / examples",
    "body": "If asked whether a fault was found and none was established: “No. This call is about checking [relevant thing] and alerting [person] if we detect a problem.” If actual finding exists, give source, test time, exact observation and uncertainty; no extrapolated loss.\n\nExamples: “A website can look fine while a customer’s request never reaches the team. If we can check that in your setup, the finding gives [person] something specific to look into.” These are examples, not findings about this prospect or promises that every configuration is supported. Never-had issue → O03 if resistance; otherwise resume. [Illustrative lead-path map](https://avertsignal.com/tools/lead-tracking-revenue-path-map/)",
    "variants": [
      {
        "id": "no-fault-found",
        "label": "no-fault-found",
        "text": "No. This call is about checking [relevant thing] and alerting [person] if we detect a problem.",
        "sourceStart": 62,
        "sourceEnd": 156
      },
      {
        "id": "example",
        "label": "example",
        "text": "A website can look fine while a customer’s request never reaches the team. If we can check that in your setup, the finding gives [person] something specific to look into.",
        "sourceStart": 277,
        "sourceEnd": 447
      }
    ],
    "quotes": [
      "No. This call is about checking [relevant thing] and alerting [person] if we detect a problem.",
      "A website can look fine while a customer’s request never reaches the team. If we can check that in your setup, the finding gives [person] something specific to look into."
    ]
  },
  "F03": {
    "id": "F03",
    "title": "Didn't see the email / saw the email / who is Blip or was it AI?",
    "body": "Didn't see: “No problem. The short version is [relevant one-sentence reason].” Saw it: “Was there a part you wanted to ask about?” If not, continue without another summary.\n\nBlip/AI outreach: “Let me check that particular message so I can tell you accurately who sent it and how it was prepared.” Verify actual campaign/message records; do not use the snapshot's unverified identity claim. Never pretend automation was human-authored. This unknown need not block unrelated product-fit discussion unless transparency about that outreach is a decision condition.",
    "variants": [
      {
        "id": "email-unseen",
        "label": "email-unseen",
        "text": "No problem. The short version is [relevant one-sentence reason].",
        "sourceStart": 13,
        "sourceEnd": 77
      },
      {
        "id": "email-seen",
        "label": "email-seen",
        "text": "Was there a part you wanted to ask about?",
        "sourceStart": 88,
        "sourceEnd": 129
      },
      {
        "id": "message-identity",
        "label": "message-identity",
        "text": "Let me check that particular message so I can tell you accurately who sent it and how it was prepared.",
        "sourceStart": 193,
        "sourceEnd": 295
      }
    ],
    "quotes": [
      "No problem. The short version is [relevant one-sentence reason].",
      "Was there a part you wanted to ask about?",
      "Let me check that particular message so I can tell you accurately who sent it and how it was prepared."
    ]
  },
  "F04": {
    "id": "F04",
    "title": "Checks scope and multiple locations",
    "body": "“We check how customers find and contact you, where requests go, and whether connected leads are left unworked or stop progressing. We notify you of findings; your team handles customer follow-up.” State the actual selected checks, rather than promising every possible system path.\n\nHubSpot is ready. Custom CRM requires Shield. Another system’s connector status or an unusual signal → F18. Website/public-only requirements do not create a CRM dependency.\n\n**Can I choose the checks?** “Yes, we agree the scope with you, within the checks the plan and your systems support.” This is agreed scope, not a promise of unlimited customization or unverified self-service toggles.\n\nMultiple locations: “We can cover multiple locations. The price follows the locations and checks included.” Use a count already supplied; ask only missing scope. Site Watch is per website; location plans use their formula. [Pricing](https://avertsignal.com/pricing/)",
    "variants": [
      {
        "id": "scope",
        "label": "scope",
        "text": "We check how customers find and contact you, where requests go, and whether connected leads are left unworked or stop progressing. We notify you of findings; your team handles customer follow-up.",
        "sourceStart": 1,
        "sourceEnd": 196
      },
      {
        "id": "choose-checks",
        "label": "Can I choose the checks?",
        "text": "Yes, we agree the scope with you, within the checks the plan and your systems support.",
        "sourceStart": 487,
        "sourceEnd": 573
      },
      {
        "id": "multiple-locations",
        "label": "Can I choose the checks?",
        "text": "We can cover multiple locations. The price follows the locations and checks included.",
        "sourceStart": 696,
        "sourceEnd": 781
      }
    ],
    "quotes": [
      "We check how customers find and contact you, where requests go, and whether connected leads are left unworked or stop progressing. We notify you of findings; your team handles customer follow-up.",
      "Yes, we agree the scope with you, within the checks the plan and your systems support.",
      "We can cover multiple locations. The price follows the locations and checks included."
    ]
  },
  "F05": {
    "id": "F05",
    "title": "Keep the CRM and existing people",
    "body": "**Replacing the CRM:** “No. You keep your CRM. AvertSignal checks for the agreed problems and notifies you; your team still works the leads.”\n\n**Provider:** “Your [named provider] keeps handling [their work]. They can use the findings from the checks you choose.” No new detection/usefulness question. A real comparison → P01, wanted input → P02.\n\n**Compatibility:** “HubSpot is ready.” A custom CRM always requires Shield; new connector build takes three business days from the customer’s IT providing required access. Details → F18. Do not promise to run follow-up sequences or contact customers. [FAQ](https://avertsignal.com/faq/)",
    "variants": [
      {
        "id": "keep-crm",
        "label": "Replacing the CRM",
        "text": "No. You keep your CRM. AvertSignal checks for the agreed problems and notifies you; your team still works the leads.",
        "sourceStart": 24,
        "sourceEnd": 140
      },
      {
        "id": "keep-provider",
        "label": "Provider",
        "text": "Your [named provider] keeps handling [their work]. They can use the findings from the checks you choose.",
        "sourceStart": 158,
        "sourceEnd": 262
      },
      {
        "id": "hubspot",
        "label": "Compatibility",
        "text": "HubSpot is ready.",
        "sourceStart": 368,
        "sourceEnd": 385
      }
    ],
    "quotes": [
      "No. You keep your CRM. AvertSignal checks for the agreed problems and notifies you; your team still works the leads.",
      "Your [named provider] keeps handling [their work]. They can use the findings from the checks you choose.",
      "HubSpot is ready."
    ]
  },
  "F06": {
    "id": "F06",
    "title": "SEO, marketing or new leads?",
    "body": "“We monitor problems that can make it harder for customers to find you, contact you or get a reply. We don’t run ads or promise new leads.” Search monitoring is not an ongoing SEO engagement or ranking guarantee. Request for implementation → I01. [Pricing](https://avertsignal.com/pricing/), [Fixes & Setup](https://avertsignal.com/fixes-and-setup/)",
    "variants": [
      {
        "id": "monitoring-not-marketing",
        "label": "monitoring-not-marketing",
        "text": "We monitor problems that can make it harder for customers to find you, contact you or get a reply. We don’t run ads or promise new leads.",
        "sourceStart": 1,
        "sourceEnd": 138
      }
    ],
    "quotes": [
      "We monitor problems that can make it harder for customers to find you, contact you or get a reply. We don’t run ads or promise new leads."
    ]
  },
  "F07": {
    "id": "F07",
    "title": "Who receives alerts and who acts",
    "body": "Answer a known delivery question directly. **Preferences still missing:** “Who needs to see the alerts, and who should handle them?” Ask only the missing half if one is known. An owner who wants visibility need not be the person doing the work.\n\nThen confirm the actual supported recipients/channel for the selected plan. If unknown: “I’ll confirm how alerts can reach [named recipients].” Capture owner-first, handler-first or mixed preference without promising an unverified configuration. A recipient selected is not an alert delivered. [Alerts and reports](https://avertsignal.com/faq/)",
    "variants": [
      {
        "id": "missing-recipient",
        "label": "Preferences still missing",
        "text": "Who needs to see the alerts, and who should handle them?",
        "sourceStart": 75,
        "sourceEnd": 131
      },
      {
        "id": "unknown-delivery",
        "label": "Preferences still missing",
        "text": "I’ll confirm how alerts can reach [named recipients].",
        "sourceStart": 335,
        "sourceEnd": 388
      }
    ],
    "quotes": [
      "Who needs to see the alerts, and who should handle them?",
      "I’ll confirm how alerts can reach [named recipients]."
    ]
  },
  "F08": {
    "id": "F08",
    "title": "Thresholds timing reports and alerts",
    "body": "Answer the actual question directly. **What a lead threshold means:** “You choose how long a lead can sit unworked or without progressing before it qualifies for a notification, for example 24 or 48 hours.” This business rule is not scan frequency or a guaranteed delivery instant.\n\n**Asked exact scan/delivery timing:** “I’ll confirm the check frequency and notification timing for that setup.” Those details remain unspecified, not assumed real time. Never turn a stalled-lead threshold into a promised one-hour reply or exact-instant alert.\n\n**Alert contents:** “We show what we found and what to check next. When the evidence confirms the cause, we explain it.” Suggestions about where to look are not confirmed causes; recorded progression is not proof of every customer interaction elsewhere.\n\n**Known dashboard/report entitlement:** state it. **Specific missing entitlement/delivery:** “I’ll check where you’d see the findings and how they reach [person].” **Noise-control request:** answer the documented control or identify the precise check. No zero-noise claim. Continue unrelated known scope when this is nonessential. [FAQ](https://avertsignal.com/faq/), [Coverage](https://avertsignal.com/what-we-protect/)",
    "variants": [
      {
        "id": "threshold",
        "label": "What a lead threshold means",
        "text": "You choose how long a lead can sit unworked or without progressing before it qualifies for a notification, for example 24 or 48 hours.",
        "sourceStart": 71,
        "sourceEnd": 205
      },
      {
        "id": "cadence",
        "label": "Asked exact scan/delivery timing",
        "text": "I’ll confirm the check frequency and notification timing for that setup.",
        "sourceStart": 322,
        "sourceEnd": 394
      },
      {
        "id": "findings",
        "label": "Alert contents",
        "text": "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
        "sourceStart": 566,
        "sourceEnd": 664
      },
      {
        "id": "unknown-entitlement",
        "label": "Specific missing entitlement/delivery",
        "text": "I’ll check where you’d see the findings and how they reach [person].",
        "sourceStart": 894,
        "sourceEnd": 962
      }
    ],
    "quotes": [
      "You choose how long a lead can sit unworked or without progressing before it qualifies for a notification, for example 24 or 48 hours.",
      "I’ll confirm the check frequency and notification timing for that setup.",
      "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
      "I’ll check where you’d see the findings and how they reach [person]."
    ]
  },
  "F09": {
    "id": "F09",
    "title": "Detection follow-up and technical fixes",
    "body": "**“Do you follow up with our leads?”:** “No. We detect stalled or unworked leads and notify you. Your team handles the customer follow-up.” Do not offer automatic customer outreach as an AvertSignal capability.\n\n**“Do you fix technical problems?”:** “Whether we can help fix that depends on the issue and your setup.” Explain only a separately verified technical response or eligible I01 project. Conditional technical repair must not be generalized into customer follow-up.\n\n**“What happens after a finding?”:** “We show what we found and what to check next. When the evidence confirms the cause, we explain it.” The relevant person handles the action; state the actual delivery route. “We recheck the original issue before calling it resolved.” Verification needs the appropriate available evidence and is not an invented repair or completion deadline. [How it works](https://avertsignal.com/how-it-works/)",
    "variants": [
      {
        "id": "customer-followup",
        "label": "“Do you follow up with our leads?”",
        "text": "No. We detect stalled or unworked leads and notify you. Your team handles the customer follow-up.",
        "sourceStart": 41,
        "sourceEnd": 138
      },
      {
        "id": "technical-fix",
        "label": "“Do you fix technical problems?”",
        "text": "Whether we can help fix that depends on the issue and your setup.",
        "sourceStart": 251,
        "sourceEnd": 316
      },
      {
        "id": "findings",
        "label": "“What happens after a finding?”",
        "text": "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
        "sourceStart": 514,
        "sourceEnd": 612
      },
      {
        "id": "recheck",
        "label": "“What happens after a finding?”",
        "text": "We recheck the original issue before calling it resolved.",
        "sourceStart": 688,
        "sourceEnd": 745
      }
    ],
    "quotes": [
      "No. We detect stalled or unworked leads and notify you. Your team handles the customer follow-up.",
      "Whether we can help fix that depends on the issue and your setup.",
      "We show what we found and what to check next. When the evidence confirms the cause, we explain it.",
      "We recheck the original issue before calling it resolved."
    ]
  },
  "F10": {
    "id": "F10",
    "title": "Guarantee / what if you miss something?",
    "body": "“We can’t promise to catch every problem or prevent every missed request. We report what we find in [agreed checks], with evidence [person] can use.”\n\nIf discussing a real miss, gather condition, time and evidence, use the account-support route, and review applicable terms. Don't invent SLA, refund, reimbursement or liability coverage. A required guarantee the service cannot make → genuine no-fit, not another reframe. [FAQ](https://avertsignal.com/faq/), [Terms](https://avertsignal.com/terms/)",
    "variants": [
      {
        "id": "no-guarantee",
        "label": "no-guarantee",
        "text": "We can’t promise to catch every problem or prevent every missed request. We report what we find in [agreed checks], with evidence [person] can use.",
        "sourceStart": 1,
        "sourceEnd": 148
      }
    ],
    "quotes": [
      "We can’t promise to catch every problem or prevent every missed request. We report what we find in [agreed checks], with evidence [person] can use."
    ]
  },
  "F11": {
    "id": "F11",
    "title": "Demo or proof",
    "body": "**A relevant approved example is available:** “I can show you an example of [what they asked about]. It’s a demo, so it doesn’t establish that your own connection works.” If the requested example is unavailable, say so and offer actual available evidence or a named verification step.\n\nUse one relevant [official simulation](https://avertsignal.com/demo/) if requested and available. Use the purpose already supplied; identify only a genuinely missing proof requirement. Show the relevant part once, then return the evidence and remaining requirements to the calling concern. There is no child proof-confirmation question followed by another parent confirmation. Exact integration → F18. Approved references → O10/F16. Planning tools and simulations are not connected live tests; do not imply their interactive behavior or the buyer’s system was tested in this review.",
    "variants": [
      {
        "id": "approved-example",
        "label": "A relevant approved example is available",
        "text": "I can show you an example of [what they asked about]. It’s a demo, so it doesn’t establish that your own connection works.",
        "sourceStart": 47,
        "sourceEnd": 169
      }
    ],
    "quotes": [
      "I can show you an example of [what they asked about]. It’s a demo, so it doesn’t establish that your own connection works."
    ]
  },
  "F12": {
    "id": "F12",
    "title": "Setup connector turnaround and active checks",
    "body": "**Existing ready HubSpot connector:** state readiness directly, then explain the actual authorized connection, threshold and recipient setup. Readiness of the connector does not prove this account is connected or active.\n\n**A new CRM connector:** “Building the connector takes three business days after your IT team provides the access we need.” For a custom CRM, Shield includes the connection with no separate connector setup fee. Use business days, not 72 hours or three clock days. Payment does not start the clock.\n\n**When checks are active:** “We confirm that [agreed checks] are running and that [named recipients] can receive the findings.” Connector completion and activation are different facts. Preserve any configuration, evidence or delivery dependency until actually satisfied.\n\nThe configured 24/48-hour threshold is a monitoring rule, not the connector build time or notification interval. Establish the account’s exact access/process before a material commitment. The custom CRM connection is included in Shield with no separate connector setup fee. Verify only any genuinely unspecified charge for a different scope. [Process](https://avertsignal.com/how-it-works/)",
    "variants": [
      {
        "id": "new-connector",
        "label": "A new CRM connector",
        "text": "Building the connector takes three business days after your IT team provides the access we need.",
        "sourceStart": 248,
        "sourceEnd": 344
      },
      {
        "id": "active-checks",
        "label": "When checks are active",
        "text": "We confirm that [agreed checks] are running and that [named recipients] can receive the findings.",
        "sourceStart": 550,
        "sourceEnd": 647
      }
    ],
    "quotes": [
      "Building the connector takes three business days after your IT team provides the access we need.",
      "We confirm that [agreed checks] are running and that [named recipients] can receive the findings."
    ]
  },
  "F13": {
    "id": "F13",
    "title": "Access and installation",
    "body": "**Exact scope and access are known:** explain the actual permissions, installation and authorizer directly. **Scope not yet known:** “The access depends on which checks you choose. Which part are you asking about?” Reuse a previously named check; do not ask again.\n\n**Exact requirement unknown:** “I’ll confirm the access needed for [named check] before you decide.” Public and connected checks differ. No universal installation/no-install claim. Review read/write scopes, authorized tests and administrator responsibilities; the customer completes sensitive credential entry securely. [Security](https://avertsignal.com/security/)",
    "variants": [
      {
        "id": "unknown-scope",
        "label": "Scope not yet known",
        "text": "The access depends on which checks you choose. Which part are you asking about?",
        "sourceStart": 134,
        "sourceEnd": 213
      },
      {
        "id": "unknown-access",
        "label": "Exact requirement unknown",
        "text": "I’ll confirm the access needed for [named check] before you decide.",
        "sourceStart": 298,
        "sourceEnd": 365
      }
    ],
    "quotes": [
      "The access depends on which checks you choose. Which part are you asking about?",
      "I’ll confirm the access needed for [named check] before you decide."
    ]
  },
  "F14": {
    "id": "F14",
    "title": "CRM records and retained customer data",
    "body": "**Whole-database question:** “AvertSignal isn’t designed to keep a duplicate of your customer database. It keeps the account, configuration and monitoring information needed to run the service.” **Specific connection:** state its documented processing/retention directly. If unknown, “I need to confirm which customer data this connection processes and keeps.”\n\nPublic disclosures describe account, configuration, monitoring, alert, integration-state and service data. They do not by themselves establish what a particular CRM connection copies. Verify the actual data flow and retention. No promise of zero customer data, fixed deletion time, residency, AI-training exclusion or certification without evidence. A material requirement remains open. [Privacy](https://avertsignal.com/privacy/), [Security](https://avertsignal.com/security/)",
    "variants": [
      {
        "id": "database-purpose",
        "label": "Whole-database question",
        "text": "AvertSignal isn’t designed to keep a duplicate of your customer database. It keeps the account, configuration and monitoring information needed to run the service.",
        "sourceStart": 30,
        "sourceEnd": 193
      },
      {
        "id": "unknown-connection-data",
        "label": "Specific connection",
        "text": "I need to confirm which customer data this connection processes and keeps.",
        "sourceStart": 285,
        "sourceEnd": 359
      }
    ],
    "quotes": [
      "AvertSignal isn’t designed to keep a duplicate of your customer database. It keeps the account, configuration and monitoring information needed to run the service.",
      "I need to confirm which customer data this connection processes and keeps."
    ]
  },
  "F15": {
    "id": "F15",
    "title": "Does the product use AI?",
    "body": "**General AI question without a confirmed disclosure:** “Let me confirm that from our current product disclosure.” **Specific analysis or data question:** “Let me confirm how [the specific analysis or data use they asked about] works before I give you an answer.”\n\nAnswer from an approved current disclosure when available. The reviewed pages do not establish feature-specific AI use; the old script alone is not current proof. Verify only the actual AI function or data question that matters to this buyer. Obtain approved use/model/provider/review/data-flow disclosures if material. Do not invent a yes/no answer or equate evidence-based monitoring with proof AI is absent. [Methodology](https://avertsignal.com/methodology/)",
    "variants": [
      {
        "id": "general-ai",
        "label": "General AI question without a confirmed disclosure",
        "text": "Let me confirm that from our current product disclosure.",
        "sourceStart": 57,
        "sourceEnd": 113
      },
      {
        "id": "specific-ai",
        "label": "Specific analysis or data question",
        "text": "Let me confirm how [the specific analysis or data use they asked about] works before I give you an answer.",
        "sourceStart": 156,
        "sourceEnd": 262
      }
    ],
    "quotes": [
      "Let me confirm that from our current product disclosure.",
      "Let me confirm how [the specific analysis or data use they asked about] works before I give you an answer."
    ]
  },
  "F16": {
    "id": "F16",
    "title": "Legitimacy and customer references",
    "body": "**Reference requested:** provide an actual approved published example or permission-cleared contact if available. If none is available: “I don’t have an approved customer reference to share. I can show you [available relevant evidence].” Never invent a client or imply unapproved endorsement.\n\n**Company identity question:** offer official company details, [contact](https://avertsignal.com/contact/), hello@avertsignal.com and current terms. **Concern still unspecified:** “What would you like to verify about the company?” A website alone is not independent validation. Specific trust concern → O10; answer the requested evidence before another question.",
    "variants": [
      {
        "id": "no-reference",
        "label": "Reference requested",
        "text": "I don’t have an approved customer reference to share. I can show you [available relevant evidence].",
        "sourceStart": 137,
        "sourceEnd": 236
      },
      {
        "id": "company-verification",
        "label": "Concern still unspecified",
        "text": "What would you like to verify about the company?",
        "sourceStart": 475,
        "sourceEnd": 523
      }
    ],
    "quotes": [
      "I don’t have an approved customer reference to share. I can show you [available relevant evidence].",
      "What would you like to verify about the company?"
    ]
  },
  "F17": {
    "id": "F17",
    "title": "Can a specific tool be replaced?",
    "body": "“Only if the actual checks and responsibilities are covered. Let's compare [named required function] before changing anything.” Unsupported equivalence → do not recommend cancellation. Unknown third-party scope → P03/N01. Proven duplication alone still does not authorize cancelling the buyer's service.",
    "variants": [
      {
        "id": "replacement",
        "label": "replacement",
        "text": "Only if the actual checks and responsibilities are covered. Let's compare [named required function] before changing anything.",
        "sourceStart": 1,
        "sourceEnd": 126
      }
    ],
    "quotes": [
      "Only if the actual checks and responsibilities are covered. Let's compare [named required function] before changing anything."
    ]
  },
  "F18": {
    "id": "F18",
    "title": "HubSpot custom CRM and a new connector",
    "body": "**HubSpot:** “HubSpot is ready.” Match the requested check to the actual authorized connection/configuration; do not reframe established readiness as unknown generic compatibility.\n\n**Custom CRM:** “A custom CRM requires Shield. The connection is included, with no separate connector setup fee.” This is a firm tier rule. Never sell Protect for the essential custom-CRM requirement to meet a budget.\n\n**New CRM connector:** “Building the connector takes three business days after your IT team provides the access we need.” Record the actual IT access dependency. The statement covers this connector, not construction or migration of the customer’s CRM, and not guaranteed activation immediately afterward.\n\n**Another named non-custom CRM:** verify whether its connector is already ready and any plan/scope rule that is not established. Do not assume every non-HubSpot product is a custom CRM or that every new connector fits Protect.\n\nCheck only the material exact signal, version/access constraint or unusual requirement needed for the wanted check. Unsupported essential requirement → honest no-fit or approved review; nonessential unknown does not block known scope. The custom CRM connection is included in Shield, with no separate connector setup fee. [Coverage](https://avertsignal.com/what-we-protect/)",
    "variants": [
      {
        "id": "hubspot",
        "label": "HubSpot",
        "text": "HubSpot is ready.",
        "sourceStart": 14,
        "sourceEnd": 31
      },
      {
        "id": "custom-crm",
        "label": "Custom CRM",
        "text": "A custom CRM requires Shield. The connection is included, with no separate connector setup fee.",
        "sourceStart": 199,
        "sourceEnd": 294
      },
      {
        "id": "new-connector",
        "label": "New CRM connector",
        "text": "Building the connector takes three business days after your IT team provides the access we need.",
        "sourceStart": 425,
        "sourceEnd": 521
      }
    ],
    "quotes": [
      "HubSpot is ready.",
      "A custom CRM requires Shield. The connection is included, with no separate connector setup fee.",
      "Building the connector takes three business days after your IT team provides the access we need."
    ]
  },
  "F19": {
    "id": "F19",
    "title": "Trial terms",
    "body": "“You can apply for a 14-day free trial. We’ll check eligibility and review the offer with you.”\n\nIf asked about the application: “Applying doesn’t automatically start a trial, create an account or sign you up for paid service.” Actual offer must establish approval, scope, start trigger, duration, payment requirement, post-trial price/renewal and cancellation. The public qualification form is not an approved offer. Material unknown → N01; relevant demo may resolve proof concern now → F11. [Trial qualification](https://avertsignal.com/free-trial/)",
    "variants": [
      {
        "id": "trial-application",
        "label": "trial-application",
        "text": "You can apply for a 14-day free trial. We’ll check eligibility and review the offer with you.",
        "sourceStart": 1,
        "sourceEnd": 94
      },
      {
        "id": "application-state",
        "label": "application-state",
        "text": "Applying doesn’t automatically start a trial, create an account or sign you up for paid service.",
        "sourceStart": 130,
        "sourceEnd": 226
      }
    ],
    "quotes": [
      "You can apply for a 14-day free trial. We’ll check eligibility and review the offer with you.",
      "Applying doesn’t automatically start a trial, create an account or sign you up for paid service."
    ]
  },
  "F20": {
    "id": "F20",
    "title": "Cancellation commitment refunds and payment terms",
    "body": "**Specific question:** give the verified term or supported payment method directly, citing the actual checkout/account agreement. **Unknown:** “I’ll confirm [specific term or payment option] before you commit.” Do not replace an answer with a vague full-terms review.\n\n**Before commitment, if material terms have not been reviewed:** “Let’s review the billing, renewal, cancellation and refund terms before you commit.” Use current account/checkout terms and applicable agreement. No unverified cancel-anytime, no-commitment, refund, invoice/PO, card/bank or net-terms promise. SMS STOP changes messaging, not the subscription. Procurement → O17. Resolved question → exact saved stage; a terms answer alone never creates purchase readiness. [Terms](https://avertsignal.com/terms/)",
    "variants": [
      {
        "id": "unknown-term",
        "label": "Unknown",
        "text": "I’ll confirm [specific term or payment option] before you commit.",
        "sourceStart": 144,
        "sourceEnd": 209
      },
      {
        "id": "terms-review",
        "label": "Before commitment, if material terms have not been reviewed",
        "text": "Let’s review the billing, renewal, cancellation and refund terms before you commit.",
        "sourceStart": 335,
        "sourceEnd": 418
      }
    ],
    "quotes": [
      "I’ll confirm [specific term or payment option] before you commit.",
      "Let’s review the billing, renewal, cancellation and refund terms before you commit."
    ]
  },
  "C01": {
    "id": "C01",
    "title": "Accepted offer to checkout without a second close",
    "body": "Entry: an informed buyer accepted the offer or explicitly asks to purchase. C01 has no default purchase invitation or unchanged-offer confirmation.\n\nUse existing scope, quantity, authority, current total, terms and concern state. Verify only missing or changed material facts. A changed plan/quantity/term invalidates the prior total and requires the changed offer to be accepted. Custom CRM remains Shield; a material integration/access/commercial dependency stays open. Do not repeat the detection/usefulness/approval decisions already settled.\n\n**Checkout mode already requested:** use it. **Offer accepted, material facts clear and delivery choice still unknown:** “Would you prefer the official checkout link, or to go through the pricing page together?” → C02. No required rep attribution or meeting.\n\n**New concern:** save current checkout decision and address it. **Actual dependency:** N01. A price question or wanted check alone is not acceptance of an unpresented offer; S06 owns that ordinary invitation.",
    "variants": [
      {
        "id": "checkout-choice",
        "label": "Offer accepted, material facts clear and delivery choice still unknown",
        "text": "Would you prefer the official checkout link, or to go through the pricing page together?",
        "sourceStart": 670,
        "sourceEnd": 758
      }
    ],
    "quotes": [
      "Would you prefer the official checkout link, or to go through the pricing page together?"
    ]
  },
  "C02": {
    "id": "C02",
    "title": "Link, guided checkout and payment state",
    "body": "Use verified official pricing/checkout route or approved current payment control. Confirm link destination and recipient before sending; never invent a checkout URL.\n\n**Link sent:** “I’ve sent the checkout link to [verified destination]. Let me know if anything on the page doesn’t match what we discussed.” Only say sent after the sending tool confirms success; this does not prove receipt or opening. **Guided pricing:** “Open the official pricing page and select [agreed plan/quantity]. Please review the total and terms before submitting.” No rep attribution gate.\n\n**Checkout open:** answer exact page question; never ask buyer to read out card details or credentials. **Buyer says paid:** “Thanks. Let's check the purchase confirmation.” Payment-reported state only until verified. **Verified purchase:** C04. **Pending/unpaid:** remain open, troubleshoot or agree next step; never mark paid. **Mismatch/error:** C03. **Later:** O15.",
    "variants": [
      {
        "id": "link-sent",
        "label": "Link sent",
        "text": "I’ve sent the checkout link to [verified destination]. Let me know if anything on the page doesn’t match what we discussed.",
        "sourceStart": 183,
        "sourceEnd": 306
      },
      {
        "id": "guided-pricing",
        "label": "Guided pricing",
        "text": "Open the official pricing page and select [agreed plan/quantity]. Please review the total and terms before submitting.",
        "sourceStart": 424,
        "sourceEnd": 542
      },
      {
        "id": "payment-reported",
        "label": "Buyer says paid",
        "text": "Thanks. Let's check the purchase confirmation.",
        "sourceStart": 696,
        "sourceEnd": 742
      }
    ],
    "quotes": [
      "I’ve sent the checkout link to [verified destination]. Let me know if anything on the page doesn’t match what we discussed.",
      "Open the official pricing page and select [agreed plan/quantity]. Please review the total and terms before submitting.",
      "Thanks. Let's check the purchase confirmation."
    ]
  },
  "C03": {
    "id": "C03",
    "title": "Payment/checkout troubleshooting",
    "body": "**Known error:** “What is the error message, without any card or bank details?” **What happened is unknown:** “What happened when you tried to check out? Please leave out card or bank details.”\n\n**Card decline:** customer checks entered details privately and follows issuer/official checkout guidance; no speculative fraud diagnosis, alternate-charge promise or repeated blind submission. **Bank issue:** customer follows bank/checkout guidance; don't assume bank payments are accepted. **Page/link issue:** verify official destination, current plan and browser/page message; use the official pricing route as safe alternative. **Uncertain charge status:** verify receipt/account transaction state before retry; do not risk duplicate payment. **Product/billing support needed:** official support route, record exact non-sensitive error and unresolved state. **Resolved:** resume C02, verify result. **Unresolved:** N01/E03 unpaid; payment failure is not loss of buyer intent or completed purchase.",
    "variants": [
      {
        "id": "known-error",
        "label": "Known error",
        "text": "What is the error message, without any card or bank details?",
        "sourceStart": 18,
        "sourceEnd": 78
      },
      {
        "id": "unknown-error",
        "label": "What happened is unknown",
        "text": "What happened when you tried to check out? Please leave out card or bank details.",
        "sourceStart": 111,
        "sourceEnd": 192
      }
    ],
    "quotes": [
      "What is the error message, without any card or bank details?",
      "What happened when you tried to check out? Please leave out card or bank details."
    ]
  },
  "C04": {
    "id": "C04",
    "title": "Verified purchase and activation handoff",
    "body": "**Say only after payment verification:** “Your purchase is confirmed. Next is [actual setup step], and we’ll confirm when your checks are running.”\n\nRecord actual plan, quantity, paid amount, receipt state and onboarding owner. No claim of active protection until configuration/connection/baseline evidence supports it. Setup obstacle → F12/O14. Existing support issue → relevant support route. Do not add unrequested implementation or upgrades after payment.",
    "variants": [
      {
        "id": "verified-purchase",
        "label": "Say only after payment verification",
        "text": "Your purchase is confirmed. Next is [actual setup step], and we’ll confirm when your checks are running.",
        "sourceStart": 42,
        "sourceEnd": 146
      }
    ],
    "quotes": [
      "Your purchase is confirmed. Next is [actual setup step], and we’ll confirm when your checks are running."
    ]
  },
  "N01": {
    "id": "N01",
    "title": "The agreed continuation and exact unresolved dependency",
    "body": "A volunteered time, zone, reviewer, requested material or channel is already settled. This card does not create a new scheduling-preference or purpose question.\n\n**Ordinary callback with time supplied:** “We’ll pick up with [unfinished topic].” Check/save the supplied date/time through the real process. Ask only for a genuinely missing date/zone or resolve a real availability conflict. Without a time, O08 obtains it once.\n\n**Named evidence/approval dependency:** “We still need [exact answer or approval]. [The action already agreed with the responsible person].” Keep the stated reviewer and requested delivery mode. Do not assign unaccepted work, ask the approval purpose again or force a meeting.\n\nIf a continuation fact is genuinely missing, ask only that fact: the recipient for requested information, the suitable callback time, or who will obtain the required answer. No default question asks the buyer to repeat the whole plan.\n\nSaved appointment with real confirmation → “You’re booked for [time/time zone].” A proposed/requested time remains unconfirmed without a save. Sent information needs an actual send result. No wanted contact → E03/E01.\n\nOn resumption, verify only actual pending dependencies and material changes/current quote; reuse answers learned while waiting and continue the next unsatisfied question or decision. An approval request is not approval; a technical review scheduled is not support established.",
    "variants": [
      {
        "id": "supplied-time",
        "label": "Ordinary callback with time supplied",
        "text": "We’ll pick up with [unfinished topic].",
        "sourceStart": 205,
        "sourceEnd": 243
      },
      {
        "id": "known-dependency",
        "label": "Named evidence/approval dependency",
        "text": "We still need [exact answer or approval]. [The action already agreed with the responsible person].",
        "sourceStart": 468,
        "sourceEnd": 566
      },
      {
        "id": "saved-appointment",
        "label": "Named evidence/approval dependency",
        "text": "You’re booked for [time/time zone].",
        "sourceStart": 985,
        "sourceEnd": 1020
      }
    ],
    "quotes": [
      "We’ll pick up with [unfinished topic].",
      "We still need [exact answer or approval]. [The action already agreed with the responsible person].",
      "You’re booked for [time/time zone]."
    ]
  },
  "E01": {
    "id": "E01",
    "title": "Stop / DNC / final refusal",
    "body": "**Say:** “Understood. I'll respect that. Take care.” End selling immediately; no clarification, isolation or final close. Apply the appropriate requested no-contact disposition through the authorized process. A promise to update a record is not proof it was updated. Keep final refusal and explicit DNC distinguishable where policy and system require, while respecting both in conversation.",
    "variants": [
      {
        "id": "stop",
        "label": "Say",
        "text": "Understood. I'll respect that. Take care.",
        "sourceStart": 10,
        "sourceEnd": 51
      }
    ],
    "quotes": [
      "Understood. I'll respect that. Take care."
    ]
  },
  "E02": {
    "id": "E02",
    "title": "Genuine no-fit or no wanted independent check",
    "body": "**Equivalent existing coverage:** “Sounds like you have what you need. I wouldn’t add another service just for the sake of it.”\n\n**Unsupported need:** “We can’t do [required thing], so I wouldn’t recommend this for what you need.” **Required guarantee:** “We can’t promise [required result]. I wouldn’t ask you to buy it on that basis.” **No wanted monitoring:** “Understood. It doesn’t sound useful for you right now.” Use the exit that matches the actual reason.\n\nUse the actual reason: no relevant supported scope, equivalent checks and no desire for a second check, unsupported core requirement, or guarantee requirement that cannot be met. No forced lower plan, invented gap or insulting provider. End or follow a buyer-requested information route. Not qualified does not mean DNC unless requested.",
    "variants": [
      {
        "id": "equivalent-coverage",
        "label": "Equivalent existing coverage",
        "text": "Sounds like you have what you need. I wouldn’t add another service just for the sake of it.",
        "sourceStart": 35,
        "sourceEnd": 126
      },
      {
        "id": "unsupported-need",
        "label": "Unsupported need",
        "text": "We can’t do [required thing], so I wouldn’t recommend this for what you need.",
        "sourceStart": 152,
        "sourceEnd": 229
      },
      {
        "id": "required-guarantee",
        "label": "Required guarantee",
        "text": "We can’t promise [required result]. I wouldn’t ask you to buy it on that basis.",
        "sourceStart": 256,
        "sourceEnd": 335
      },
      {
        "id": "no-wanted-check",
        "label": "No wanted monitoring",
        "text": "Understood. It doesn’t sound useful for you right now.",
        "sourceStart": 364,
        "sourceEnd": 418
      }
    ],
    "quotes": [
      "Sounds like you have what you need. I wouldn’t add another service just for the sake of it.",
      "We can’t do [required thing], so I wouldn’t recommend this for what you need.",
      "We can’t promise [required result]. I wouldn’t ask you to buy it on that basis.",
      "Understood. It doesn’t sound useful for you right now."
    ]
  },
  "E03": {
    "id": "E03",
    "title": "Not proceeding now / no affordable suitable plan / drop active queue",
    "body": "**Say:** “Understood. Let’s leave it there. [Only the next step the buyer agreed to].”\n\nReal trigger and welcomed future contact → N01/nurture by agreed trigger. No next step wanted → close out active pursuit. No affordable plan that covers the essential need → say that plainly; don't under-scope silently. No scheduled date or purchase claim. Retain factual reason and unresolved dependency without turning a soft maybe into a commitment.",
    "variants": [
      {
        "id": "not-proceeding",
        "label": "Say",
        "text": "Understood. Let’s leave it there. [Only the next step the buyer agreed to].",
        "sourceStart": 10,
        "sourceEnd": 85
      }
    ],
    "quotes": [
      "Understood. Let’s leave it there. [Only the next step the buyer agreed to]."
    ]
  },
  "I01": {
    "id": "I01",
    "title": "One-time work, separate from monitoring",
    "body": "**Say:** “What would you like changed, and who handles that today?” If already known, skip it. “We can look at that as a one-time job and agree on the work and price first. You don’t have to buy monitoring with it.”\n\nProtect a capable provider's role. Only offer AvertSignal implementation for an expressly wanted eligible gap or requested change. Establish needed deliverable, existing platform/assets, account ownership, access, standard scope, exclusions, revisions and timeline before commitment. Custom CRM/API/database workflows, complex migration, large architecture or unsupported work → nonstandard review; no invented price/date.\n\n**Implementation only:** proceed to scoped project quote I02, not mandatory subscription. **Monitoring still independently useful:** keep separate scope and quote; resume its saved stage. **Existing provider should handle it:** offer findings to them through an authorized route; no replacement pitch. [Official project boundaries](https://avertsignal.com/fixes-and-setup/): customer keeps domain/accounts/site/code/data as applicable; no required maintenance contract or website lease. Third-party recurring costs remain customer-owned and paid directly.",
    "variants": [
      {
        "id": "unknown-work",
        "label": "Say",
        "text": "What would you like changed, and who handles that today?",
        "sourceStart": 10,
        "sourceEnd": 66
      },
      {
        "id": "one-time-work",
        "label": "Say",
        "text": "We can look at that as a one-time job and agree on the work and price first. You don’t have to buy monitoring with it.",
        "sourceStart": 96,
        "sourceEnd": 214
      }
    ],
    "quotes": [
      "What would you like changed, and who handles that today?",
      "We can look at that as a one-time job and agree on the work and price first. You don’t have to buy monitoring with it."
    ]
  },
  "I02": {
    "id": "I02",
    "title": "Approved implementation price and scope card",
    "body": "Use this as a lookup after scope is established, never as an opening menu or a quote for unresolved work. Canonical USD pricing from the current Pricing Engine:\n\n- Launch Site $499: one page, roughly five sections, simple form/click-to-call, customer inputs, basic technical hygiene, one revision.\n- Launch Site+ $749: one page with materially fuller copy/content/strategy, roughly eight sections and enhanced standard setup as needed; two revisions.\n- Business Website: 3 pages $1,295; 5 pages $1,795; 8 pages $2,495. Additional standard page $175 up to ten total; distinct localized location/service-area content page $225. More than ten/complex architecture/substantial migration → review.\n- Website Refresh: one page $599; up to five $1,295; six–ten $1,995. Rebuild, replatform, complex migration or custom features → review.\n- GBP create/claim/configure $299; verified-profile cleanup $199. Customer completes required verification.\n- Local Search Foundation $499 including meaningful GBP work; $399 when GBP is healthy and needs no substantive work. Not ongoing SEO or ranking guarantee.\n- Business Email Setup first mailbox/domain $149; +$50 each additional mailbox; more than five/complex migration → review. Provider subscription separate.\n- Brand Starter $299; usable-logo cleanup/export $149; serious identity strategy → review.\n- Lead/Booking Setup: simple embed/link to configured tool $99; standard form or existing-tool setup $199; more involved standard no-code configuration $299; custom API/database/app work → review.\n- Review Starter link/QR/request-template/site-link package $99. No fake reviews or review gating.\n- Social Presence Setup one profile $149; up to three $299; fourth/fifth +$75 each; more than five or recurring management → review/refer.\n- Copywriting only when not included: one-page upgrade $199, +$100 each additional standard page; complex regulated/technical/legal/long-form → review.\n- Domain registration/connection/transfer assistance $99; registrar fees separate.\n- Additional revision rounds: Launch $75, Launch+ $100, Business Website / multi-page refresh $150. The extra-round price for a one-page refresh is not established here; verify before quoting. New pages/features/integrations/redesign after approval/material expansion are separately priced change orders, not revisions.\n\n**Payment:** project under $1,000: 100% before production; $1,000 or more: 50% to start, 50% before final launch/handoff unless owner-approved exception. Confirm actual agreement and timeline. No promised start or completion date from the price alone.\n\n**Price resistance:** first O04/O05/O06. Remove unnecessary scope before discounting; state exactly what is removed. Never remove essential technical hygiene or rename a scope reduction a discount.\n\n**Concessions:** recurring fees have zero standing rep discount authority. Eligible one-time bundle: two services up to 5%; three or more up to 10%, capped $250. Same-scope closing concession up to 5% only after standard fit/scope, willingness to buy, price isolated as remaining blocker, no better smaller scope, and decision-now/concrete commitment condition. Combined concessions no more than 10% and $250 without owner approval. Exclude third-party fees/pass-through and already reduced scope variants from inappropriate discount treatment. Never split line items to evade caps.\n\n**Say when qualified:** “The agreed work is [deliverables] for [one-time total], with [payment structure]. [Exclusions, ownership and timeline]. Do you want to proceed on that basis?” Apply current agreement approval and payment flow. If quote not justified by known scope, label preliminary and name exact missing fact; no false final quote.\n\n**Quote record:** selected scope, base price, adjustments, eligible subtotal, concession and reason, final one-time total, separate recurring formula/total, payment terms, approval status, exclusions. Approval status is REP AUTHORIZED, OWNER APPROVAL REQUIRED, or ESCALATE — NON-STANDARD SCOPE.",
    "variants": [
      {
        "id": "qualified-project-offer",
        "label": "Say when qualified",
        "text": "The agreed work is [deliverables] for [one-time total], with [payment structure]. [Exclusions, ownership and timeline]. Do you want to proceed on that basis?",
        "sourceStart": 3392,
        "sourceEnd": 3549
      }
    ],
    "quotes": [
      "The agreed work is [deliverables] for [one-time total], with [payment structure]. [Exclusions, ownership and timeline]. Do you want to proceed on that basis?"
    ]
  }
};
export const V9_CROSSWALK: readonly V9SourcePurpose[] = [
  {
    "old_id": "OPEN-001",
    "old_title": "Universal cold-call opener",
    "new_card": "S01",
    "treatment": "Changed",
    "reason": "Known buyer goes to relevance; role question only when role unknown. Mandatory permission gate removed."
  },
  {
    "old_id": "OWNER-FRAME",
    "old_title": "Agree a brief conversation",
    "new_card": "S01",
    "treatment": "Changed",
    "reason": "Known buyer goes to relevance; role question only when role unknown. Mandatory permission gate removed."
  },
  {
    "old_id": "PROTECTION-THESIS",
    "old_title": "Explain the reason for the call",
    "new_card": "S01",
    "treatment": "Merged",
    "reason": "Service purpose and reason to listen are established in S01 before the single S03 awareness question."
  },
  {
    "old_id": "CORE-PROTECTION",
    "old_title": "Understand detection today",
    "new_card": "S03",
    "treatment": "Merged",
    "reason": "Merged into the single detection/awareness exchange; no additional notification question."
  },
  {
    "old_id": "GAP-DIAGNOSIS",
    "old_title": "Find a useful check",
    "new_card": "S04",
    "treatment": "Merged",
    "reason": "Merged into one relevant explanation and one wanted-check judgment; no separate impact or reason-to-act gate."
  },
  {
    "old_id": "AGENCY-CHECK",
    "old_title": "Understand provider detection",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "AGENCY-FIX",
    "old_title": "Separate fixing from detection",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "AGENCY-PROACTIVE",
    "old_title": "Check for duplication",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "AGENCY-UNSURE",
    "old_title": "Clarify provider coverage",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "CORE-UNSURE",
    "old_title": "Coverage is not yet established",
    "new_card": "S04",
    "treatment": "Merged",
    "reason": "Merged into one relevant explanation and one wanted-check judgment; no separate impact or reason-to-act gate."
  },
  {
    "old_id": "EXISTING-PROTECTION",
    "old_title": "Assess existing checks",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "FRAGMENTED",
    "old_title": "Assess combined coverage",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "ONE-SYSTEM",
    "old_title": "One-system claim",
    "new_card": "P01",
    "treatment": "Changed",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "KNOWN-SYSTEM",
    "old_title": "Assess the named system",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "UNKNOWN-SYSTEM",
    "old_title": "Assess an unfamiliar system",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "UNKNOWN-RESEARCH",
    "old_title": "Requested comparison follow-up",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "UNKNOWN-UNSURE",
    "old_title": "Coverage needs verification",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "EXISTING-UNSURE",
    "old_title": "Confirm what is watched",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "PRESCRIBE",
    "old_title": "Prescribe one plan",
    "new_card": "S06",
    "treatment": "Merged",
    "reason": "Complete fitting offer and one ordinary purchase invitation; no additional readiness close."
  },
  {
    "old_id": "PRICE",
    "old_title": "Price",
    "new_card": "S07",
    "treatment": "Merged",
    "reason": "Direct price answer; full quantity formula; exact saved return for early interruptions."
  },
  {
    "old_id": "CLOSE",
    "old_title": "Ask for the sale",
    "new_card": "S06",
    "treatment": "Merged",
    "reason": "The one ordinary purchase invitation belongs to S06; C01 performs only material-gap handling and checkout."
  },
  {
    "old_id": "CHECKOUT-CHOICE",
    "old_title": "Checkout choice",
    "new_card": "C01",
    "treatment": "Merged",
    "reason": "Accepted offer or explicit informed buy goes to material gaps and checkout without a second purchase invitation."
  },
  {
    "old_id": "SEND-LINK",
    "old_title": "Use existing payment controls",
    "new_card": "C02",
    "treatment": "Merged",
    "reason": "Public payment route, optional attribution, link/open/reported-paid states separated."
  },
  {
    "old_id": "WALK-THROUGH",
    "old_title": "Guide them to checkout",
    "new_card": "C02",
    "treatment": "Merged",
    "reason": "Public payment route, optional attribution, link/open/reported-paid states separated."
  },
  {
    "old_id": "CHECKOUT-OPEN",
    "old_title": "Checkout active",
    "new_card": "C02",
    "treatment": "Merged",
    "reason": "Public payment route, optional attribution, link/open/reported-paid states separated."
  },
  {
    "old_id": "PAID",
    "old_title": "Payment reported; confirmation pending",
    "new_card": "C02",
    "treatment": "Merged",
    "reason": "Public payment route, optional attribution, link/open/reported-paid states separated."
  },
  {
    "old_id": "GK-AROUND",
    "old_title": "Right person identified",
    "new_card": "G01",
    "treatment": "Merged",
    "reason": "Role/owner/coordinator/unknown handling retained honestly."
  },
  {
    "old_id": "GK-TRANSFER",
    "old_title": "Transfer request",
    "new_card": "G02",
    "treatment": "Merged",
    "reason": "Transfer, reason and explicit sales-call answer retained."
  },
  {
    "old_id": "GK-NOT-HERE",
    "old_title": "Decision maker unavailable",
    "new_card": "G03",
    "treatment": "Merged",
    "reason": "Unavailable person/email preference; verify recipient and distinguish suggested versus booked callback."
  },
  {
    "old_id": "GK-WHAT",
    "old_title": "Gatekeeper asks what this is about",
    "new_card": "G02",
    "treatment": "Merged",
    "reason": "Transfer, reason and explicit sales-call answer retained."
  },
  {
    "old_id": "GK-SALES",
    "old_title": "Gatekeeper asks if it is sales",
    "new_card": "G02",
    "treatment": "Merged",
    "reason": "Transfer, reason and explicit sales-call answer retained."
  },
  {
    "old_id": "GK-EMAIL",
    "old_title": "Identify the right recipient",
    "new_card": "G03",
    "treatment": "Merged",
    "reason": "Unavailable person/email preference; verify recipient and distinguish suggested versus booked callback."
  },
  {
    "old_id": "GK-CAN-HELP",
    "old_title": "Gatekeeper says they can help",
    "new_card": "G01",
    "treatment": "Merged",
    "reason": "Role/owner/coordinator/unknown handling retained honestly."
  },
  {
    "old_id": "GK-UNSURE",
    "old_title": "Gatekeeper unsure who handles it",
    "new_card": "G01",
    "treatment": "Merged",
    "reason": "Role/owner/coordinator/unknown handling retained honestly."
  },
  {
    "old_id": "GK-GENERIC",
    "old_title": "Routing unresolved",
    "new_card": "G04",
    "treatment": "Direct",
    "reason": "General inbox and unresolved ownership retain truthful non-qualified exit."
  },
  {
    "old_id": "RESEARCH-ANCHOR",
    "old_title": "Research anchor",
    "new_card": "S02",
    "treatment": "Changed",
    "reason": "Research optional; correct factual record rather than defend preliminary observation."
  },
  {
    "old_id": "RESEARCH-CORRECT",
    "old_title": "Research correction",
    "new_card": "S02",
    "treatment": "Changed",
    "reason": "Research optional; correct factual record rather than defend preliminary observation."
  },
  {
    "old_id": "WHY-AVERTSIGNAL",
    "old_title": "Connect the need to supported coverage",
    "new_card": "S06",
    "treatment": "Merged",
    "reason": "Complete fitting offer and one ordinary purchase invitation; no additional readiness close."
  },
  {
    "old_id": "PRIORITY-FRONT-END",
    "old_title": "Agree the Google scope",
    "new_card": "S05",
    "treatment": "Merged",
    "reason": "Distinct fit/configuration facts only; accepted usefulness and volunteered system/threshold/quantity/authority are not re-asked."
  },
  {
    "old_id": "PRIORITY-HANDOFF",
    "old_title": "Agree the handoff scope",
    "new_card": "S05",
    "treatment": "Merged",
    "reason": "Distinct fit/configuration facts only; accepted usefulness and volunteered system/threshold/quantity/authority are not re-asked."
  },
  {
    "old_id": "PRIORITY-BROAD",
    "old_title": "Keep the scope focused",
    "new_card": "S05",
    "treatment": "Merged",
    "reason": "Distinct fit/configuration facts only; accepted usefulness and volunteered system/threshold/quantity/authority are not re-asked."
  },
  {
    "old_id": "PRIORITY-CONTACT",
    "old_title": "Agree the contact-path scope",
    "new_card": "S05",
    "treatment": "Merged",
    "reason": "Distinct fit/configuration facts only; accepted usefulness and volunteered system/threshold/quantity/authority are not re-asked."
  },
  {
    "old_id": "ROUTE-OWNER",
    "old_title": "Agree alert priorities",
    "new_card": "F07",
    "treatment": "Merged",
    "reason": "Owner/provider/mixed preference retained; actual recipients/delivery verified."
  },
  {
    "old_id": "ROUTE-HANDLER",
    "old_title": "Agree alert priorities",
    "new_card": "F07",
    "treatment": "Merged",
    "reason": "Owner/provider/mixed preference retained; actual recipients/delivery verified."
  },
  {
    "old_id": "ROUTE-MIX",
    "old_title": "Agree alert priorities",
    "new_card": "F07",
    "treatment": "Merged",
    "reason": "Owner/provider/mixed preference retained; actual recipients/delivery verified."
  },
  {
    "old_id": "ALERT-NORMAL",
    "old_title": "Confirm supported alerting",
    "new_card": "F08",
    "treatment": "Merged",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "ALERT-ALL",
    "old_title": "Set accurate alert expectations",
    "new_card": "F08",
    "treatment": "Merged",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "NEED-DISCOVERY",
    "old_title": "Establish one useful need",
    "new_card": "S04",
    "treatment": "Merged",
    "reason": "Merged into one relevant explanation and one wanted-check judgment; no separate impact or reason-to-act gate."
  },
  {
    "old_id": "IMPACT-DISCOVERY",
    "old_title": "Understand why it matters",
    "new_card": "S04",
    "treatment": "Merged",
    "reason": "Merged into one relevant explanation and one wanted-check judgment; no separate impact or reason-to-act gate."
  },
  {
    "old_id": "COVERAGE-FOLLOWUP",
    "old_title": "Check coverage before recommending",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "NO-NEED",
    "old_title": "No additional need",
    "new_card": "E02",
    "treatment": "Direct",
    "reason": "Honest no-fit/no wanted check; no forced problem."
  },
  {
    "old_id": "NOT-PROCEEDING",
    "old_title": "Not proceeding today",
    "new_card": "E03",
    "treatment": "Merged",
    "reason": "Reason/permission-based next step or close out; no fictional commitment."
  },
  {
    "old_id": "FOLLOWUP-REQUEST",
    "old_title": "Requested follow-up",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "READINESS",
    "old_title": "Confirm the recommendation",
    "new_card": "S06",
    "treatment": "Merged",
    "reason": "Complete fitting offer and one ordinary purchase invitation; no additional readiness close."
  },
  {
    "old_id": "OBJ-THINK",
    "old_title": "I need to think about it",
    "new_card": "O02",
    "treatment": "Merged",
    "reason": "Specific uncertainty diagnosed; voluntary thinking time respected."
  },
  {
    "old_id": "OBJ-THINK-VAGUE",
    "old_title": "Isolate the remaining uncertainty",
    "new_card": "O02",
    "treatment": "Merged",
    "reason": "Specific uncertainty diagnosed; voluntary thinking time respected."
  },
  {
    "old_id": "OBJ-EXPENSIVE",
    "old_title": "It’s too expensive",
    "new_card": "O04",
    "treatment": "Merged",
    "reason": "One price classification only if actual concern unknown; stated cap/comparison/dependency directly determines the answer."
  },
  {
    "old_id": "OBJ-VALUE",
    "old_title": "Clarify value",
    "new_card": "O04",
    "treatment": "Merged",
    "reason": "One price classification only if actual concern unknown; stated cap/comparison/dependency directly determines the answer."
  },
  {
    "old_id": "OBJ-VALUE-COMPARE",
    "old_title": "Compare actual scope",
    "new_card": "P03",
    "treatment": "Merged",
    "reason": "Fair documented comparison; wanted supported difference or honest no-fit."
  },
  {
    "old_id": "OBJ-BUDGET",
    "old_title": "It’s not in the budget",
    "new_card": "O05",
    "treatment": "Merged",
    "reason": "A stated firm cap goes directly to smallest sufficient scope; custom CRM remains Shield and unaffordable essential scope exits honestly."
  },
  {
    "old_id": "OBJ-BUDGET-UNPLANNED",
    "old_title": "Separate value from unplanned spend",
    "new_card": "O05",
    "treatment": "Merged",
    "reason": "A stated firm cap goes directly to smallest sufficient scope; custom CRM remains Shield and unaffordable essential scope exits honestly."
  },
  {
    "old_id": "OBJ-CHEAPER",
    "old_title": "Do you have something cheaper?",
    "new_card": "O06",
    "treatment": "Merged",
    "reason": "Scope reduction versus concession; recurring exception needs approval."
  },
  {
    "old_id": "OBJ-LOWER-PLAN",
    "old_title": "Move to a lighter plan",
    "new_card": "O06",
    "treatment": "Merged",
    "reason": "Scope reduction versus concession; recurring exception needs approval."
  },
  {
    "old_id": "OBJ-HOLD-PLAN",
    "old_title": "Hold the prescribed plan",
    "new_card": "O06",
    "treatment": "Merged",
    "reason": "Scope reduction versus concession; recurring exception needs approval."
  },
  {
    "old_id": "OBJ-DISCOUNT",
    "old_title": "Can you discount it?",
    "new_card": "O06",
    "treatment": "Merged",
    "reason": "Scope reduction versus concession; recurring exception needs approval."
  },
  {
    "old_id": "OBJ-DISCOUNT-CHECK",
    "old_title": "Just checking for room",
    "new_card": "O06",
    "treatment": "Merged",
    "reason": "Scope reduction versus concession; recurring exception needs approval."
  },
  {
    "old_id": "OBJ-ROI",
    "old_title": "What’s the ROI?",
    "new_card": "O04",
    "treatment": "Merged",
    "reason": "One price classification only if actual concern unknown; stated cap/comparison/dependency directly determines the answer."
  },
  {
    "old_id": "OBJ-TRIAL",
    "old_title": "Can I try it first?",
    "new_card": "O12",
    "treatment": "Changed",
    "reason": "Proof goal and qualified-trial route; actual offer still verified."
  },
  {
    "old_id": "OBJ-SEND",
    "old_title": "Send me something",
    "new_card": "O13",
    "treatment": "Merged",
    "reason": "Decision-specific information and recipient permission; no forced follow-up."
  },
  {
    "old_id": "OBJ-SEND-VAGUE",
    "old_title": "Send whatever — vague stall",
    "new_card": "O13",
    "treatment": "Merged",
    "reason": "Decision-specific information and recipient permission; no forced follow-up."
  },
  {
    "old_id": "OBJ-NOT-NOW",
    "old_title": "Not right now",
    "new_card": "O07",
    "treatment": "Merged",
    "reason": "Exact not-today line; real dependency or desired delay, no invented urgency."
  },
  {
    "old_id": "OBJ-NOT-NOW-VAGUE",
    "old_title": "Not now — still vague",
    "new_card": "O07",
    "treatment": "Merged",
    "reason": "Exact not-today line; real dependency or desired delay, no invented urgency."
  },
  {
    "old_id": "OBJ-CALL-EARLY",
    "old_title": "Busy / callback — early",
    "new_card": "O08",
    "treatment": "Merged",
    "reason": "Early/mid/close callback branches preserve exact stage and genuine availability."
  },
  {
    "old_id": "OBJ-CALL-MID",
    "old_title": "Call me later — mid-call",
    "new_card": "O08",
    "treatment": "Merged",
    "reason": "Early/mid/close callback branches preserve exact stage and genuine availability."
  },
  {
    "old_id": "OBJ-CALL-CLOSE",
    "old_title": "Call me later — at close",
    "new_card": "O08",
    "treatment": "Merged",
    "reason": "Early/mid/close callback branches preserve exact stage and genuine availability."
  },
  {
    "old_id": "OBJ-CALL-CLOSE-NO-DEP",
    "old_title": "Close callback with no future dependency",
    "new_card": "O08",
    "treatment": "Merged",
    "reason": "Early/mid/close callback branches preserve exact stage and genuine availability."
  },
  {
    "old_id": "OBJ-AUTH",
    "old_title": "Need partner / spouse / boss",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-REAL",
    "old_title": "Include the decision makers",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-COMFORT",
    "old_title": "Buyer wants another opinion",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-PRICE",
    "old_title": "Understand the price concern",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-WHY",
    "old_title": "Explain the recommendation accurately",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-DONT-KNOW",
    "old_title": "Define the other opinion",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-TRUST",
    "old_title": "Trust / proof concern",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-SCHEDULE",
    "old_title": "Arrange a specific continuation",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "OBJ-SCHEDULE-CLOSE",
    "old_title": "Arrange a specific continuation",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "OBJ-SCHEDULE-SECOND",
    "old_title": "Arrange a specific continuation",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "OBJ-SCHEDULED",
    "old_title": "Arrange a specific continuation",
    "new_card": "N01",
    "treatment": "Merged",
    "reason": "Use supplied callback/reviewer/material facts; obtain only a distinct missing continuation fact and resume the next unsatisfied decision."
  },
  {
    "old_id": "OBJ-DROP",
    "old_title": "Drop from active queue",
    "new_card": "E03",
    "treatment": "Merged",
    "reason": "Reason/permission-based next step or close out; no fictional commitment."
  },
  {
    "old_id": "OBJ-AUTH-NOT-OPPOSED",
    "old_title": "Buyer decides",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-MAYBE",
    "old_title": "Absent party may object",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-AUTH-STILL-ASK",
    "old_title": "Respect the requested involvement",
    "new_card": "O09",
    "treatment": "Merged",
    "reason": "Use named approver/purpose immediately; preserve actual review mode and separate price, recommendation or unknown-opinion concerns."
  },
  {
    "old_id": "OBJ-SECURITY",
    "old_title": "Security / privacy concern",
    "new_card": "O11",
    "treatment": "Merged",
    "reason": "Access, retention and change control explicit; exact security concern confirmed before return."
  },
  {
    "old_id": "OBJ-SECURITY-CHANGE",
    "old_title": "What can change?",
    "new_card": "O11",
    "treatment": "Merged",
    "reason": "Access, retention and change control explicit; exact security concern confirmed before return."
  },
  {
    "old_id": "OBJ-LEGIT",
    "old_title": "How do I know you’re legitimate?",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-REFERENCES",
    "old_title": "References / proof",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-REFERENCES-POLICY",
    "old_title": "Approved evidence",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-ALREADY-COVERED",
    "old_title": "We already have this covered",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-FRAGMENTED",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Changed",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-UNCERTAIN",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Changed",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-KNOWN-PARTIAL",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Changed",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-REACTIVE-AGENCY",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-PROACTIVE-AGENCY",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-COVERED-GENERIC",
    "old_title": "Assess the earlier coverage answer",
    "new_card": "P01",
    "treatment": "Merged",
    "reason": "Specific provider boundary/comparison response only; does not restart detection or usefulness decisions."
  },
  {
    "old_id": "OBJ-NEVER-HAD",
    "old_title": "Everything has worked so far",
    "new_card": "O03",
    "treatment": "Direct",
    "reason": "Healthy operation is compatible with independent verification; no invented loss."
  },
  {
    "old_id": "OBJ-NO-URGENCY",
    "old_title": "No urgency",
    "new_card": "O07",
    "treatment": "Merged",
    "reason": "Exact not-today line; real dependency or desired delay, no invented urgency."
  },
  {
    "old_id": "OBJ-NO-URGENCY-REFRAME",
    "old_title": "Return to the real priority",
    "new_card": "O07",
    "treatment": "Merged",
    "reason": "Exact not-today line; real dependency or desired delay, no invented urgency."
  },
  {
    "old_id": "OBJ-COMPETITOR",
    "old_title": "Another tool / provider",
    "new_card": "P03",
    "treatment": "Merged",
    "reason": "Fair documented comparison; wanted supported difference or honest no-fit."
  },
  {
    "old_id": "OBJ-COMPETITOR-PARTIAL",
    "old_title": "Compare the uncovered check",
    "new_card": "P03",
    "treatment": "Merged",
    "reason": "Fair documented comparison; wanted supported difference or honest no-fit."
  },
  {
    "old_id": "OBJ-SETUP",
    "old_title": "Setup workload",
    "new_card": "O14",
    "treatment": "Merged",
    "reason": "Time/access/technical workload branches and exact return."
  },
  {
    "old_id": "OBJ-CHECKOUT-LATER",
    "old_title": "Checkout later",
    "new_card": "O15",
    "treatment": "Merged",
    "reason": "Identify unfinished checkout concern; no pressure against preferred later timing."
  },
  {
    "old_id": "OBJ-CHECKOUT-NOCHANGE",
    "old_title": "Complete or agree a useful next step",
    "new_card": "O15",
    "treatment": "Merged",
    "reason": "Identify unfinished checkout concern; no pressure against preferred later timing."
  },
  {
    "old_id": "OBJ-PAYMENT",
    "old_title": "Payment / checkout problem",
    "new_card": "C03",
    "treatment": "Merged",
    "reason": "Card/bank/page errors and uncertain charge status; verify before retry."
  },
  {
    "old_id": "OBJ-PAYMENT-CARD",
    "old_title": "Card issue",
    "new_card": "C03",
    "treatment": "Merged",
    "reason": "Card/bank/page errors and uncertain charge status; verify before retry."
  },
  {
    "old_id": "OBJ-PAYMENT-BANK",
    "old_title": "Bank issue",
    "new_card": "C03",
    "treatment": "Merged",
    "reason": "Card/bank/page errors and uncertain charge status; verify before retry."
  },
  {
    "old_id": "OBJ-PAYMENT-PAGE",
    "old_title": "Page / link issue",
    "new_card": "C03",
    "treatment": "Merged",
    "reason": "Card/bank/page errors and uncertain charge status; verify before retry."
  },
  {
    "old_id": "OBJ-TOO-SMALL",
    "old_title": "Small business fit",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-TOO-SMALL-YES",
    "old_title": "Assess the fitting scope",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-TOO-BIG",
    "old_title": "Internal team coverage",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-REFERRALS",
    "old_title": "Referral business",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-NOCRM",
    "old_title": "We don’t use a CRM",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-NOWEBSITE",
    "old_title": "We don’t really use our website",
    "new_card": "O16",
    "treatment": "Merged",
    "reason": "Dedicated size/referral/no-CRM/no-site branches; no automatic tier or website upsell."
  },
  {
    "old_id": "OBJ-PROCUREMENT",
    "old_title": "Procurement / legal",
    "new_card": "O17",
    "treatment": "Merged",
    "reason": "Named procurement/legal/invoice/PO/cancel dependency; current terms verified."
  },
  {
    "old_id": "OBJ-INVOICE-PO",
    "old_title": "Invoice / PO / vendor setup",
    "new_card": "O17",
    "treatment": "Merged",
    "reason": "Named procurement/legal/invoice/PO/cancel dependency; current terms verified."
  },
  {
    "old_id": "OBJ-CANCEL",
    "old_title": "Am I locked in / what are cancellation terms?",
    "new_card": "O17",
    "treatment": "Merged",
    "reason": "Named procurement/legal/invoice/PO/cancel dependency; current terms verified."
  },
  {
    "old_id": "OBJ-REFUSAL",
    "old_title": "Stop / clear refusal",
    "new_card": "E01",
    "treatment": "Merged",
    "reason": "Stop/refusal ends immediately and honors no-contact request."
  },
  {
    "old_id": "END-REFUSAL",
    "old_title": "Respect refusal",
    "new_card": "E01",
    "treatment": "Merged",
    "reason": "Stop/refusal ends immediately and honors no-contact request."
  },
  {
    "old_id": "OBJ-READY",
    "old_title": "Ready to buy early",
    "new_card": "O18",
    "treatment": "Direct",
    "reason": "Universal fast-buy route skips unnecessary discovery, not material facts."
  },
  {
    "old_id": "OBJ-IMPLEMENTATION",
    "old_title": "Implementation / fixing request",
    "new_card": "I01",
    "treatment": "Merged",
    "reason": "Implementation-only scope/ownership/provider/price/timing, with I02 approved pricing."
  },
  {
    "old_id": "IMPLEMENTATION-FOLLOWUP",
    "old_title": "Scope implementation separately",
    "new_card": "I01",
    "treatment": "Merged",
    "reason": "Implementation-only scope/ownership/provider/price/timing, with I02 approved pricing."
  },
  {
    "old_id": "OBJ-NO-AFFORDABLE-FIT",
    "old_title": "No affordable suitable plan today",
    "new_card": "E03",
    "treatment": "Merged",
    "reason": "Reason/permission-based next step or close out; no fictional commitment."
  },
  {
    "old_id": "OBJ-PRICE-INFO",
    "old_title": "Pricing information",
    "new_card": "S07",
    "treatment": "Merged",
    "reason": "Direct price answer; full quantity formula; exact saved return for early interruptions."
  },
  {
    "old_id": "OBJ-OWNER-TIME",
    "old_title": "Arrange a specific continuation",
    "new_card": "O08",
    "treatment": "Merged",
    "reason": "Early/mid/close callback branches preserve exact stage and genuine availability."
  },
  {
    "old_id": "OBJ-TRUST-RETURN",
    "old_title": "Check the remaining trust concern",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-TRIAL-RETURN",
    "old_title": "Resolve the trial question",
    "new_card": "O12",
    "treatment": "Changed",
    "reason": "Proof goal and qualified-trial route; actual offer still verified."
  },
  {
    "old_id": "OBJ-NOT-INTERESTED",
    "old_title": "Not interested — first objection",
    "new_card": "O01",
    "treatment": "Merged",
    "reason": "First ordinary refusal gets relevant clarification; final refusal bypasses selling."
  },
  {
    "old_id": "OBJ-RELEVANCE",
    "old_title": "Test relevance once",
    "new_card": "O01",
    "treatment": "Merged",
    "reason": "First ordinary refusal gets relevant clarification; final refusal bypasses selling."
  },
  {
    "old_id": "OBJ-PROVIDER",
    "old_title": "I need to check with my provider",
    "new_card": "P02",
    "treatment": "Merged",
    "reason": "Coverage, reassurance and verification stay distinct; preserve actual provider dependency."
  },
  {
    "old_id": "OBJ-PROVIDER-COVERAGE",
    "old_title": "Check detection and accountability",
    "new_card": "P02",
    "treatment": "Merged",
    "reason": "Coverage, reassurance and verification stay distinct; preserve actual provider dependency."
  },
  {
    "old_id": "OBJ-PROVIDER-REASSURANCE",
    "old_title": "Isolate the provider concern",
    "new_card": "P02",
    "treatment": "Merged",
    "reason": "Coverage, reassurance and verification stay distinct; preserve actual provider dependency."
  },
  {
    "old_id": "OBJ-PROVIDER-EQUIVALENT",
    "old_title": "Equivalent coverage may already exist",
    "new_card": "P02",
    "treatment": "Merged",
    "reason": "Coverage, reassurance and verification stay distinct; preserve actual provider dependency."
  },
  {
    "old_id": "OBJ-PROVIDER-VERIFY",
    "old_title": "Define the coverage question",
    "new_card": "P02",
    "treatment": "Merged",
    "reason": "Coverage, reassurance and verification stay distinct; preserve actual provider dependency."
  },
  {
    "old_id": "OBJ-PROVIDER-CONTRACT",
    "old_title": "Confirm a real contract dependency",
    "new_card": "O17",
    "treatment": "Merged",
    "reason": "Named procurement/legal/invoice/PO/cancel dependency; current terms verified."
  },
  {
    "old_id": "OBJ-PROVIDER-TECHNICAL",
    "old_title": "Confirm access and compatibility",
    "new_card": "F18",
    "treatment": "Merged",
    "reason": "HubSpot ready; custom CRM always Shield; new connector access-triggered three-business-day build; precise remaining dependencies."
  },
  {
    "old_id": "OBJ-SEND-RETURN",
    "old_title": "Make the information useful",
    "new_card": "O13",
    "treatment": "Merged",
    "reason": "Decision-specific information and recipient permission; no forced follow-up."
  },
  {
    "old_id": "OBJ-SECURITY-RETURN",
    "old_title": "Resolve the security concern",
    "new_card": "O11",
    "treatment": "Merged",
    "reason": "Access, retention and change control explicit; exact security concern confirmed before return."
  },
  {
    "old_id": "OBJ-LEGIT-RETURN",
    "old_title": "Resolve the proof concern",
    "new_card": "O10",
    "treatment": "Merged",
    "reason": "Relevant proof, approved references and explicit return; no invented endorsement."
  },
  {
    "old_id": "OBJ-SETUP-RETURN",
    "old_title": "Resolve the setup concern",
    "new_card": "O14",
    "treatment": "Merged",
    "reason": "Time/access/technical workload branches and exact return."
  },
  {
    "old_id": "Q-WHAT-PROTECT",
    "old_title": "What do you mean by protect?",
    "new_card": "F01",
    "treatment": "Merged",
    "reason": "Plain scope explanation with no universal visibility or insurance implication."
  },
  {
    "old_id": "Q-WHOLE-PATH",
    "old_title": "What do you mean by the whole way?",
    "new_card": "F01",
    "treatment": "Merged",
    "reason": "Plain scope explanation with no universal visibility or insurance implication."
  },
  {
    "old_id": "Q-NO-EMAIL",
    "old_title": "I didn’t see the emails",
    "new_card": "F03",
    "treatment": "Merged",
    "reason": "Email seen/unseen and message-specific AI identity verification."
  },
  {
    "old_id": "Q-SAW-EMAIL",
    "old_title": "I saw the emails",
    "new_card": "F03",
    "treatment": "Merged",
    "reason": "Email seen/unseen and message-specific AI identity verification."
  },
  {
    "old_id": "Q-BLIP",
    "old_title": "Who’s Blip / was that AI?",
    "new_card": "F03",
    "treatment": "Changed",
    "reason": "Email seen/unseen and message-specific AI identity verification."
  },
  {
    "old_id": "Q-WHATS-THIS",
    "old_title": "What’s this about?",
    "new_card": "F01",
    "treatment": "Merged",
    "reason": "Plain scope explanation with no universal visibility or insurance implication."
  },
  {
    "old_id": "Q-WRONG",
    "old_title": "Did you find something wrong?",
    "new_card": "F02",
    "treatment": "Merged",
    "reason": "Concrete examples distinguished from verified buyer findings."
  },
  {
    "old_id": "Q-NEVER",
    "old_title": "We've never had a problem",
    "new_card": "F02",
    "treatment": "Merged",
    "reason": "Concrete examples distinguished from verified buyer findings."
  },
  {
    "old_id": "Q-EXAMPLES",
    "old_title": "What kind of things?",
    "new_card": "F02",
    "treatment": "Merged",
    "reason": "Concrete examples distinguished from verified buyer findings."
  },
  {
    "old_id": "Q-WATCH",
    "old_title": "What do you watch?",
    "new_card": "F04",
    "treatment": "Merged",
    "reason": "Selected checks and quantity pricing; no unlimited scope."
  },
  {
    "old_id": "Q-AGENCY",
    "old_title": "Does this replace my agency?",
    "new_card": "F05",
    "treatment": "Merged",
    "reason": "Provider/IT complement and CRM distinction retained."
  },
  {
    "old_id": "Q-FIX",
    "old_title": "Do you fix things too?",
    "new_card": "F09",
    "treatment": "Merged",
    "reason": "Findings/owner/recheck and conditional response; fixing separately scoped."
  },
  {
    "old_id": "Q-IT",
    "old_title": "Does this replace IT?",
    "new_card": "F05",
    "treatment": "Merged",
    "reason": "Provider/IT complement and CRM distinction retained."
  },
  {
    "old_id": "Q-SEO",
    "old_title": "Is this SEO / marketing?",
    "new_card": "F06",
    "treatment": "Merged",
    "reason": "Monitoring versus campaign/new-lead service made explicit."
  },
  {
    "old_id": "Q-LEADS",
    "old_title": "Do you generate leads?",
    "new_card": "F06",
    "treatment": "Merged",
    "reason": "Monitoring versus campaign/new-lead service made explicit."
  },
  {
    "old_id": "Q-ACCESS",
    "old_title": "What access do you need?",
    "new_card": "F13",
    "treatment": "Direct",
    "reason": "Exact access/installation checks; no blanket read-only or no-install claim."
  },
  {
    "old_id": "Q-ALERTS",
    "old_title": "Who gets the alerts?",
    "new_card": "F07",
    "treatment": "Merged",
    "reason": "Owner/provider/mixed preference retained; actual recipients/delivery verified."
  },
  {
    "old_id": "Q-DASH",
    "old_title": "How do I see the findings?",
    "new_card": "F08",
    "treatment": "Changed",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "Q-REPORT",
    "old_title": "Do I get reports too?",
    "new_card": "F08",
    "treatment": "Changed",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "Q-FREQ",
    "old_title": "How often are you checking?",
    "new_card": "F08",
    "treatment": "Merged",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "Q-NOISE",
    "old_title": "Will this create too much noise?",
    "new_card": "F08",
    "treatment": "Merged",
    "reason": "Dashboard, summaries, interval and noise handling restored as precise checks, not unsupported blanket claims."
  },
  {
    "old_id": "Q-GUARANTEE",
    "old_title": "Can you guarantee we won’t lose leads?",
    "new_card": "F10",
    "treatment": "Changed",
    "reason": "No guarantee or invented miss remedy."
  },
  {
    "old_id": "Q-MISS",
    "old_title": "What if AvertSignal misses something?",
    "new_card": "F10",
    "treatment": "Changed",
    "reason": "No guarantee or invented miss remedy."
  },
  {
    "old_id": "Q-DEMO",
    "old_title": "Can I see a demo?",
    "new_card": "F11",
    "treatment": "Direct",
    "reason": "Verified official simulation route; not operational integration proof."
  },
  {
    "old_id": "Q-MULTI",
    "old_title": "Does this work for multiple locations?",
    "new_card": "F04",
    "treatment": "Merged",
    "reason": "Selected checks and quantity pricing; no unlimited scope."
  },
  {
    "old_id": "Q-ONBOARD",
    "old_title": "What happens after I buy?",
    "new_card": "F12",
    "treatment": "Changed",
    "reason": "HubSpot readiness; new connector three business days from required IT access; active monitoring verified separately."
  },
  {
    "old_id": "Q-TOOLS",
    "old_title": "Can it replace other tools?",
    "new_card": "F17",
    "treatment": "Direct",
    "reason": "Actual equivalence before any replacement recommendation."
  },
  {
    "old_id": "Q-AI",
    "old_title": "Does AvertSignal use AI?",
    "new_card": "F15",
    "treatment": "Changed",
    "reason": "Product AI answer explicitly unknown pending approved disclosure."
  },
  {
    "old_id": "Q-DATA",
    "old_title": "Are you copying our CRM / customer data?",
    "new_card": "F14",
    "treatment": "Direct",
    "reason": "Current privacy-based processing/retention answer; exact requirements verified."
  },
  {
    "old_id": "Q-CRM",
    "old_title": "Is this another CRM?",
    "new_card": "F05",
    "treatment": "Merged",
    "reason": "Provider/IT complement and CRM distinction retained."
  },
  {
    "old_id": "Q-CRM-UNSUPPORTED",
    "old_title": "What if you don't support our CRM?",
    "new_card": "F18",
    "treatment": "Merged",
    "reason": "HubSpot ready; custom CRM always Shield; new connector access-triggered three-business-day build; precise remaining dependencies."
  },
  {
    "old_id": "Q-FIND",
    "old_title": "What happens when you find something?",
    "new_card": "F09",
    "treatment": "Merged",
    "reason": "Findings/owner/recheck and conditional response; fixing separately scoped."
  },
  {
    "old_id": "Q-CHOOSE",
    "old_title": "Can I choose what you monitor?",
    "new_card": "F04",
    "treatment": "Merged",
    "reason": "Selected checks and quantity pricing; no unlimited scope."
  },
  {
    "old_id": "Q-TRIAL-TERMS",
    "old_title": "What are the trial terms?",
    "new_card": "F19",
    "treatment": "Changed",
    "reason": "Public 14-day qualification request differs from approved trial and billing offer."
  }
];
export const V9_LEGACY_ALIASES: Readonly<Record<string, V9CardId>> = Object.fromEntries(V9_CROSSWALK.map(row => [row.old_id, row.new_card]));
export function v9Card(id: string): V9SourceCard | undefined { return V9_CARDS[id as V9CardId]; }
export function v9Variant(id: V9CardId, variantId: string): string | undefined { return V9_CARDS[id].variants.find(variant => variant.id === variantId)?.text; }

// Section 2 shared language; the saved stage and unresolved concern stack control applicability.
export const V9_SHARED_OBJECTION_LANGUAGE = {
  "clarify": "What specifically is giving you pause?",
  "isolateAtDecision": "Before we decide, is there another concern we should cover?",
  "topicUncertainty": "Is there another part of [topic] you want me to explain?",
  "confirm": "Does that settle [specific concern], or is part of it still open?",
  "earlyReturn": "Coming back to [unfinished question], [ask only the missing part].",
  "lateReturn": "Then [plan] covers [confirmed scope] at [verified total]. Ready to get it started?",
  "earlySecondClarification": "Which part is still unclear?",
  "decisionSecondClarification": "What specifically is still holding you back?"
} as const;
